/* @ds-bundle: {"format":4,"namespace":"EvolvedElementsDesignSystem_057731","components":[{"name":"Button","sourcePath":"components/core/Button.jsx"},{"name":"Eyebrow","sourcePath":"components/core/Eyebrow.jsx"},{"name":"Icon","sourcePath":"components/core/Icon.jsx"},{"name":"Measured","sourcePath":"components/core/Measured.jsx"},{"name":"VerifiableBlock","sourcePath":"components/core/VerifiableBlock.jsx"},{"name":"ComparisonTable","sourcePath":"components/data/ComparisonTable.jsx"},{"name":"ProofChart","sourcePath":"components/data/ProofChart.jsx"},{"name":"TextField","sourcePath":"components/forms/TextField.jsx"},{"name":"MechanismDiagram","sourcePath":"components/mechanism/MechanismDiagram.jsx"},{"name":"AnnouncementBar","sourcePath":"components/navigation/AnnouncementBar.jsx"},{"name":"SiteHeader","sourcePath":"components/navigation/SiteHeader.jsx"},{"name":"StickyBuyBar","sourcePath":"components/navigation/StickyBuyBar.jsx"},{"name":"HeroStack","sourcePath":"components/page/HeroStack.jsx"},{"name":"Section","sourcePath":"components/page/Section.jsx"},{"name":"DisclosurePanel","sourcePath":"components/proof/DisclosurePanel.jsx"},{"name":"FootnotedClaim","sourcePath":"components/proof/FootnotedClaim.jsx"},{"name":"GuaranteeLockup","sourcePath":"components/proof/GuaranteeLockup.jsx"},{"name":"LotBlock","sourcePath":"components/proof/LotBlock.jsx"},{"name":"VerbatimQuote","sourcePath":"components/proof/VerbatimQuote.jsx"}],"sourceHashes":{"components/core/Button.jsx":"298a91d5e7fb","components/core/Eyebrow.jsx":"14254dcf118b","components/core/Icon.jsx":"5a1f33cff93a","components/core/Measured.jsx":"7a3fbd49d9d2","components/core/VerifiableBlock.jsx":"567efa067b1c","components/data/ComparisonTable.jsx":"066d6d2fce82","components/data/ProofChart.jsx":"993d8455214d","components/forms/TextField.jsx":"809ced820e32","components/mechanism/MechanismDiagram.jsx":"fe6e420ab79c","components/navigation/AnnouncementBar.jsx":"93ebf39e1254","components/navigation/SiteHeader.jsx":"055b155e4584","components/navigation/StickyBuyBar.jsx":"96d3e67cc0aa","components/page/HeroStack.jsx":"3a614c9b27e3","components/page/Section.jsx":"54242d9c4cbc","components/proof/DisclosurePanel.jsx":"6ba8a0854ddb","components/proof/FootnotedClaim.jsx":"d9a08f68c776","components/proof/GuaranteeLockup.jsx":"983dc6846cfa","components/proof/LotBlock.jsx":"5e7337145191","components/proof/VerbatimQuote.jsx":"3c7c68f690e3","ui_kits/amazon/ListingSlots.jsx":"df6ed2a61c15","ui_kits/email/EmailTemplates.jsx":"ef660a24da3e","ui_kits/kit-guard.js":"828602b30e41","ui_kits/paid_social/Artboards.jsx":"fe18901ac67d","ui_kits/web/EvidencePage.jsx":"fd6dc66cb147","ui_kits/web/LandingPage.jsx":"2f8a9a773eab","ui_kits/web/ProductPage.jsx":"51d981796860","ui_kits/web/WebShell.jsx":"66d623d6e3e3"},"inlinedExternals":[],"unexposedExports":[]} */

(() => {

const __ds_ns = (window.EvolvedElementsDesignSystem_057731 = window.EvolvedElementsDesignSystem_057731 || {});

const __ds_scope = {};

(__ds_ns.__errors = __ds_ns.__errors || []);

// components/core/Button.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Exactly two above the fold. One solid, one ghost. Never three.
   Primary = outcome verb. Secondary = the document. */
function Button({
  variant = 'primary',
  size = 'default',
  href,
  onClick,
  disabled = false,
  fullWidth = false,
  type = 'button',
  children,
  style,
  ...rest
}) {
  const isGhost = variant === 'secondary';
  const isPill = variant === 'pill';
  const base = {
    display: 'inline-flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 'var(--ee-2)',
    boxSizing: 'border-box',
    minHeight: size === 'compact' ? 'var(--ee-tap-min)' : 'var(--ee-btn-h)',
    minWidth: 'var(--ee-tap-min)',
    padding: size === 'compact' ? '10px 20px' : 'var(--ee-btn-pad)',
    borderRadius: 'var(--ee-radius-btn)',
    fontFamily: 'var(--ee-font-prose)',
    fontSize: size === 'compact' ? 'var(--ee-micro)' : 'var(--ee-h4)',
    fontWeight: 'var(--ee-w-semibold)',
    lineHeight: 1.2,
    textDecoration: 'none',
    textAlign: 'center',
    width: fullWidth ? '100%' : 'auto',
    cursor: disabled ? 'not-allowed' : 'pointer',
    /* No shadow. Paper does not float. */
    boxShadow: 'none',
    transition: 'background-color 160ms ease-out, border-color 160ms ease-out, color 160ms ease-out',
    ...style
  };
  const skins = {
    primary: {
      background: disabled ? 'var(--ee-quiet)' : 'var(--ee-verify)',
      color: disabled ? 'var(--ee-limit)' : 'var(--ee-ground)',
      border: 'none'
    },
    secondary: {
      background: 'transparent',
      color: disabled ? 'var(--ee-limit)' : 'var(--ee-verify)',
      border: `var(--ee-ghost-border-w) solid ${disabled ? 'var(--ee-border)' : 'var(--ee-verify)'}`
    },
    /* The guarantee nav item: ghost pill, Verification border, mono label. */
    pill: {
      background: 'transparent',
      color: 'var(--ee-verify)',
      border: `1px solid var(--ee-verify)`,
      fontFamily: 'var(--ee-font-mono)',
      fontSize: 'var(--ee-micro)',
      fontWeight: 'var(--ee-w-medium)',
      minHeight: 'var(--ee-tap-min)',
      padding: '8px 18px'
    }
  };
  const merged = {
    ...base,
    ...(skins[variant] || skins.primary)
  };
  const Tag = href && !disabled ? 'a' : 'button';
  return /*#__PURE__*/React.createElement(Tag, _extends({}, rest, {
    href: href && !disabled ? href : undefined,
    type: Tag === 'button' ? type : undefined,
    onClick: disabled ? undefined : onClick,
    disabled: Tag === 'button' ? disabled : undefined,
    "aria-disabled": disabled || undefined,
    style: merged,
    onMouseEnter: e => {
      if (disabled) return;
      if (isGhost || isPill) e.currentTarget.style.background = 'var(--ee-verify-tint)';else e.currentTarget.style.background = '#0A4643';
    },
    onMouseLeave: e => {
      if (disabled) return;
      e.currentTarget.style.background = merged.background;
    }
  }), children);
}
Object.assign(__ds_scope, { Button });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Button.jsx", error: String((e && e.message) || e) }); }

// components/core/Eyebrow.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Mono eyebrow / column head. The only uppercase in the system.
   12 / 1.40 / 0.12em / 500 — 11px on mobile. */
function Eyebrow({
  tone = 'limit',
  as: Tag = 'div',
  children,
  style,
  ...rest
}) {
  const colors = {
    ink: 'var(--ee-ink)',
    limit: 'var(--ee-limit)',
    /* Only when the eyebrow itself names a document. */
    verify: 'var(--ee-verify)',
    mechanism: 'var(--ee-mechanism)'
  };
  return /*#__PURE__*/React.createElement(Tag, _extends({}, rest, {
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: 'var(--ee-label)',
      lineHeight: 'var(--ee-lh-label)',
      letterSpacing: 'var(--ee-tr-label)',
      fontWeight: 'var(--ee-w-medium)',
      textTransform: 'uppercase',
      color: colors[tone] || colors.limit,
      fontVariantNumeric: 'tabular-nums',
      ...style
    }
  }), children);
}
Object.assign(__ds_scope, { Eyebrow });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Eyebrow.jsx", error: String((e && e.message) || e) }); }

// components/core/Icon.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Icon rules, enforced. Line only, single 1.5px weight, Ink, no fill,
   never inside a coloured circle. No icon may imply evidence.
   NOTE: Evolved Elements ships no icon set. This wrapper renders Lucide
   (https://lucide.dev) as a flagged substitution — see readme.md > Iconography.
   Requires the Lucide UMD script on the page:
   <script src="https://unpkg.com/lucide@latest/dist/umd/lucide.js"></script> */
function Icon({
  name,
  size = 20,
  tone = 'ink',
  label,
  style,
  ...rest
}) {
  const ref = React.useRef(null);
  const colors = {
    ink: 'var(--ee-ink)',
    ink2: 'var(--ee-ink-2)',
    limit: 'var(--ee-limit)',
    /* Legal ONLY when the icon itself is a link to a document. */
    verify: 'var(--ee-verify)',
    inherit: 'currentColor'
  };
  React.useEffect(() => {
    const el = ref.current;
    if (!el || !window.lucide) return;
    el.innerHTML = '';
    const slot = document.createElement('i');
    slot.setAttribute('data-lucide', name);
    el.appendChild(slot);
    window.lucide.createIcons({
      attrs: {
        'stroke-width': 1.5,
        width: size,
        height: size,
        stroke: 'currentColor',
        fill: 'none'
      },
      nameAttr: 'data-lucide',
      root: el
    });
  }, [name, size]);
  return /*#__PURE__*/React.createElement("span", _extends({}, rest, {
    ref: ref,
    role: label ? 'img' : 'presentation',
    "aria-label": label || undefined,
    "aria-hidden": label ? undefined : true,
    style: {
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: size,
      height: size,
      flex: '0 0 auto',
      color: colors[tone] || colors.ink,
      ...style
    }
  }));
}
Object.assign(__ds_scope, { Icon });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Icon.jsx", error: String((e && e.message) || e) }); }

// components/core/Measured.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* EVERY number, dose, lot code, price, date and label.
   Not a style choice — it is how the reader tells a measured value from a
   marketing sentence. Tabular figures always on. */
function Measured({
  as: Tag = 'span',
  size = 'inherit',
  weight = 400,
  tone = 'ink',
  children,
  style,
  ...rest
}) {
  const sizes = {
    inherit: 'inherit',
    label: 'var(--ee-label)',
    micro: 'var(--ee-micro)',
    bodyS: 'var(--ee-body-s)',
    body: 'var(--ee-body)',
    h3: 'var(--ee-h3)',
    h2: 'var(--ee-h2)',
    display: 'var(--ee-display)'
  };
  const colors = {
    ink: 'var(--ee-ink)',
    ink2: 'var(--ee-ink-2)',
    limit: 'var(--ee-limit)',
    verify: 'var(--ee-verify)',
    mechanism: 'var(--ee-mechanism)'
  };
  return /*#__PURE__*/React.createElement(Tag, _extends({}, rest, {
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontVariantNumeric: 'tabular-nums',
      fontSize: sizes[size] || sizes.inherit,
      fontWeight: weight,
      color: colors[tone] || colors.ink,
      ...style
    }
  }), children);
}
Object.assign(__ds_scope, { Measured });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/Measured.jsx", error: String((e && e.message) || e) }); }

// components/core/VerifiableBlock.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* THE SIGNATURE DEVICE.
   A 2pt left rule in Verification marks anything that can be checked.
   Never decorative: if it has the rule, the reader can open it.
   Radius 0 — verification blocks are never rounded. */
function VerifiableBlock({
  tone = 'verify',
  surface = 'card',
  padded = true,
  children,
  style,
  ...rest
}) {
  const rules = {
    verify: 'var(--ee-verify)',
    /* A quote is testimony, not a document — Ink rule instead. */
    ink: 'var(--ee-ink)'
  };
  const surfaces = {
    card: 'var(--ee-card)',
    quiet: 'var(--ee-quiet)',
    ground: 'var(--ee-ground)',
    none: 'transparent'
  };
  return /*#__PURE__*/React.createElement("div", _extends({}, rest, {
    style: {
      borderLeft: `var(--ee-verify-rule) solid ${rules[tone] || rules.verify}`,
      borderRadius: 'var(--ee-radius-verify)',
      background: surfaces[surface] || surfaces.card,
      padding: padded ? 'var(--ee-3) var(--ee-4)' : 0,
      paddingLeft: padded ? 'var(--ee-4)' : 'var(--ee-4)',
      boxShadow: 'none',
      ...style
    }
  }), children);
}
Object.assign(__ds_scope, { VerifiableBlock });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/core/VerifiableBlock.jsx", error: String((e && e.message) || e) }); }

// components/data/ComparisonTable.jsx
try { (() => {
/* Comparison, including the row we lose on purpose.
   Table header on Deep. Every measured value in mono. */
function ComparisonTable({
  columns = [],
  rows = [],
  caption,
  style
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--ee-wide-col)',
      ...style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      overflowX: 'auto'
    }
  }, /*#__PURE__*/React.createElement("table", {
    style: {
      width: '100%',
      borderCollapse: 'collapse',
      minWidth: 560
    }
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    style: {
      background: 'var(--ee-deep)'
    }
  }, columns.map((c, i) => /*#__PURE__*/React.createElement("th", {
    key: c,
    scope: "col",
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: 'var(--ee-label)',
      letterSpacing: 'var(--ee-tr-label)',
      fontWeight: 'var(--ee-w-medium)',
      textTransform: 'uppercase',
      color: 'var(--ee-ink)',
      textAlign: i === 0 ? 'left' : 'center',
      padding: 'var(--ee-3) var(--ee-4)',
      verticalAlign: 'bottom'
    }
  }, c)))), /*#__PURE__*/React.createElement("tbody", null, rows.map(r => /*#__PURE__*/React.createElement("tr", {
    key: r.label,
    style: {
      borderBottom: 'var(--ee-rule-w) solid var(--ee-rule)',
      background: r.weLose ? 'var(--ee-quiet)' : 'transparent'
    }
  }, /*#__PURE__*/React.createElement("th", {
    scope: "row",
    style: {
      textAlign: 'left',
      fontSize: 'var(--ee-body-s)',
      lineHeight: 'var(--ee-lh-body-s)',
      fontWeight: 'var(--ee-w-regular)',
      color: 'var(--ee-ink)',
      padding: 'var(--ee-3) var(--ee-4)'
    }
  }, r.label, r.weLose && /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    size: "label",
    tone: "limit",
    style: {
      display: 'block',
      letterSpacing: 'var(--ee-tr-label)',
      marginTop: 'var(--ee-1)'
    }
  }, "THE ROW WE LOSE")), r.values.map((v, i) => /*#__PURE__*/React.createElement("td", {
    key: i,
    style: {
      textAlign: 'center',
      padding: 'var(--ee-3) var(--ee-4)',
      fontSize: 'var(--ee-body-s)',
      color: 'var(--ee-ink-2)'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    size: "bodyS",
    weight: i === 0 ? 600 : 400,
    tone: i === 0 ? 'ink' : 'ink2'
  }, v)))))))), caption && /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: 'var(--ee-micro)',
      lineHeight: 'var(--ee-lh-micro)',
      color: 'var(--ee-limit)',
      marginTop: 'var(--ee-3)'
    }
  }, caption));
}
Object.assign(__ds_scope, { ComparisonTable });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/data/ComparisonTable.jsx", error: String((e && e.message) || e) }); }

// components/data/ProofChart.jsx
try { (() => {
/* Charts.
   Measured values in mono, axis labelled, ONE accent, ground and rules from
   the palette. A chart without its denominator is not allowed on any Evolved
   Elements surface — if n is unknown, the chart does not ship.
   Every label names a value the chart actually reaches. */
function ProofChart({
  eyebrow,
  series = [],
  max,
  denominator,
  axisLabel,
  accent = 'verify',
  style
}) {
  const accents = {
    verify: 'var(--ee-verify)',
    mechanism: 'var(--ee-mechanism)'
  };
  const colour = accents[accent] || accents.verify;
  const ceiling = max ?? Math.max(...series.map(s => s.value), 1);

  /* If n is unknown, the chart does not ship. */
  if (!denominator) {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        borderLeft: 'var(--ee-verify-rule) solid var(--ee-border)',
        padding: 'var(--ee-3) var(--ee-4)',
        ...style
      }
    }, /*#__PURE__*/React.createElement(__ds_scope.Measured, {
      size: "micro",
      tone: "limit"
    }, "Chart withheld: no denominator supplied. A chart without its n does not ship."));
  }
  return /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0,
      maxWidth: 'var(--ee-wide-col)',
      ...style
    }
  }, eyebrow && /*#__PURE__*/React.createElement(__ds_scope.Eyebrow, {
    style: {
      marginBottom: 'var(--ee-4)'
    }
  }, eyebrow), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--ee-3)'
    }
  }, series.map(s => /*#__PURE__*/React.createElement("div", {
    key: s.label,
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) auto',
      gap: 'var(--ee-3)',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 'var(--ee-body-s)',
      lineHeight: 'var(--ee-lh-body-s)',
      marginBottom: 'var(--ee-1)'
    }
  }, s.label), /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--ee-deep)',
      height: 'var(--ee-5)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: `${Math.min(100, s.value / ceiling * 100)}%`,
      height: '100%',
      background: s.muted ? 'var(--ee-rule)' : colour
    }
  }))), /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    size: "bodyS",
    weight: 600,
    tone: s.muted ? 'limit' : 'ink',
    style: {
      minWidth: '7ch',
      textAlign: 'right'
    }
  }, s.display ?? s.value)))), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: 'var(--ee-micro)',
      lineHeight: 'var(--ee-lh-micro)',
      color: 'var(--ee-limit)',
      marginTop: 'var(--ee-4)',
      paddingTop: 'var(--ee-3)',
      borderTop: 'var(--ee-rule-w) solid var(--ee-rule)'
    }
  }, axisLabel ? `${axisLabel} · ` : '', "n = ", denominator));
}
Object.assign(__ds_scope, { ProofChart });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/data/ProofChart.jsx", error: String((e && e.message) || e) }); }

// components/forms/TextField.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* Labels ABOVE fields, never placeholder-as-label.
   Errors in TEXT, not colour. Real border, focus ring always visible. */
function TextField({
  id,
  label,
  type = 'text',
  value,
  onChange,
  hint,
  error,
  required = false,
  mono = false,
  placeholder,
  style,
  ...rest
}) {
  const fieldId = id || `f-${label.replace(/\W+/g, '-').toLowerCase()}`;
  const hintId = hint ? `${fieldId}-hint` : undefined;
  const errId = error ? `${fieldId}-err` : undefined;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--ee-2)',
      ...style
    }
  }, /*#__PURE__*/React.createElement("label", {
    htmlFor: fieldId,
    style: {
      fontSize: 'var(--ee-body-s)',
      lineHeight: 1.3,
      fontWeight: 'var(--ee-w-medium)',
      color: 'var(--ee-ink)'
    }
  }, label, required && /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--ee-ink-2)'
    }
  }, " (required)")), hint && /*#__PURE__*/React.createElement("p", {
    id: hintId,
    style: {
      fontSize: 'var(--ee-micro)',
      lineHeight: 'var(--ee-lh-micro)',
      color: 'var(--ee-limit)'
    }
  }, hint), /*#__PURE__*/React.createElement("input", _extends({}, rest, {
    id: fieldId,
    type: type,
    value: value,
    onChange: onChange,
    placeholder: placeholder,
    required: required,
    "aria-describedby": [hintId, errId].filter(Boolean).join(' ') || undefined,
    "aria-invalid": error ? true : undefined,
    style: {
      minHeight: 'var(--ee-tap-min)',
      padding: 'var(--ee-3) var(--ee-4)',
      background: 'var(--ee-card)',
      color: 'var(--ee-ink)',
      border: `var(--ee-border-w) solid var(--ee-border)`,
      borderRadius: 'var(--ee-radius)',
      fontFamily: mono ? 'var(--ee-font-mono)' : 'var(--ee-font-prose)',
      fontSize: 'var(--ee-body-s)',
      lineHeight: 'var(--ee-lh-body-s)',
      fontVariantNumeric: mono ? 'tabular-nums' : 'normal',
      boxShadow: 'none',
      width: '100%',
      boxSizing: 'border-box'
    }
  })), error && /*#__PURE__*/React.createElement("p", {
    id: errId,
    role: "alert",
    style: {
      fontSize: 'var(--ee-micro)',
      lineHeight: 'var(--ee-lh-micro)',
      color: 'var(--ee-ink)',
      borderLeft: `var(--ee-verify-rule) solid var(--ee-ink)`,
      paddingLeft: 'var(--ee-3)'
    }
  }, error));
}
Object.assign(__ds_scope, { TextField });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/forms/TextField.jsx", error: String((e && e.message) || e) }); }

// components/mechanism/MechanismDiagram.jsx
try { (() => {
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/* The mechanism diagram.
   ALWAYS EXACTLY TWO NODES — a third node kills the counter-position, because
   the argument is that there are two. Site 1 #0E5A57 · Site 2 #8A5A18.
   The limit line ships with the diagram, every time.
   Forbidden: anthropomorphised organs, cartoon thyroids, glowing bodies,
   anatomical stock renders, arrows implying a claimed biological effect. */

function Node({
  index,
  title,
  sku,
  dose,
  count,
  colour
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      minWidth: 0,
      background: 'var(--ee-card)',
      borderLeft: `var(--ee-verify-rule) solid ${colour}`,
      borderRadius: 'var(--ee-radius-verify)',
      padding: 'var(--ee-4) var(--ee-5)'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    size: "label",
    weight: 600,
    style: {
      color: colour,
      letterSpacing: 'var(--ee-tr-label)',
      display: 'block',
      marginBottom: 'var(--ee-2)'
    }
  }, index), /*#__PURE__*/React.createElement("h4", {
    style: {
      fontSize: 'var(--ee-h3)',
      lineHeight: 'var(--ee-lh-h3)',
      fontWeight: 'var(--ee-w-semibold)',
      margin: `0 0 var(--ee-3)`
    }
  }, title), /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    size: "micro",
    tone: "ink2",
    weight: 500,
    style: {
      display: 'block',
      letterSpacing: '0.04em'
    }
  }, sku.toUpperCase(), " \xB7 ", dose), count && /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    size: "micro",
    tone: "limit",
    style: {
      display: 'block',
      marginTop: 'var(--ee-1)'
    }
  }, count));
}
function MechanismDiagram({
  orientation = 'horizontal',
  eyebrow = 'Two sites, one pathway',
  connectorLabel = 'travels',
  siteOne = {
    title: 'The gland makes it',
    sku: 'Thyroid glandular',
    dose: '200 mg',
    count: '60 capsules'
  },
  siteTwo = {
    title: 'The liver activates it',
    sku: 'Beef liver gentle',
    dose: '3,000 mg',
    count: '180 capsules'
  },
  limitLine = 'The exact share of conversion the liver performs is still argued over in the literature. We say where the work happens, what it is built from, and what is in the bottle.',
  style
}) {
  const vertical = orientation === 'vertical';
  return /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0,
      maxWidth: 'var(--ee-wide-col)',
      ...style
    }
  }, eyebrow && /*#__PURE__*/React.createElement(__ds_scope.Eyebrow, {
    style: {
      marginBottom: 'var(--ee-4)'
    }
  }, eyebrow), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: vertical ? 'column' : 'row',
      alignItems: 'stretch',
      gap: 0
    }
  }, /*#__PURE__*/React.createElement(Node, _extends({
    index: "01"
  }, siteOne, {
    colour: "var(--ee-verify)"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      flexDirection: vertical ? 'row' : 'column',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 'var(--ee-2)',
      padding: vertical ? 'var(--ee-3) 0' : `0 var(--ee-4)`,
      flex: '0 0 auto'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--ee-border)',
      width: vertical ? '1px' : 'var(--ee-6)',
      height: vertical ? 'var(--ee-6)' : '1px'
    }
  }), /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    size: "label",
    tone: "limit",
    style: {
      letterSpacing: 'var(--ee-tr-label)',
      textTransform: 'uppercase',
      whiteSpace: 'nowrap'
    }
  }, connectorLabel), /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--ee-border)',
      width: vertical ? '1px' : 'var(--ee-6)',
      height: vertical ? 'var(--ee-6)' : '1px'
    }
  })), /*#__PURE__*/React.createElement(Node, _extends({
    index: "02"
  }, siteTwo, {
    colour: "var(--ee-mechanism)"
  }))), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      fontSize: 'var(--ee-micro)',
      lineHeight: 'var(--ee-lh-micro)',
      color: 'var(--ee-limit)',
      marginTop: 'var(--ee-4)',
      paddingTop: 'var(--ee-3)',
      borderTop: 'var(--ee-rule-w) solid var(--ee-rule)',
      maxWidth: 'var(--ee-measure)'
    }
  }, limitLine));
}
Object.assign(__ds_scope, { MechanismDiagram });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/mechanism/MechanismDiagram.jsx", error: String((e && e.message) || e) }); }

// components/navigation/AnnouncementBar.jsx
try { (() => {
/* The announcement bar carries CONTENT, not a discount — the slot where
   24 of 31 brands run a coupon. */
function AnnouncementBar({
  children,
  href,
  linkLabel = 'Open it →',
  style
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--ee-quiet)',
      borderBottom: 'var(--ee-rule-w) solid var(--ee-rule)',
      padding: 'var(--ee-3) var(--ee-gutter)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 'var(--ee-3)',
      flexWrap: 'wrap',
      ...style
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    size: "micro",
    tone: "ink2",
    style: {
      letterSpacing: '0.02em'
    }
  }, children), href && /*#__PURE__*/React.createElement("a", {
    href: href,
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: 'var(--ee-micro)',
      color: 'var(--ee-verify)'
    }
  }, linkLabel));
}
Object.assign(__ds_scope, { AnnouncementBar });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/AnnouncementBar.jsx", error: String((e && e.message) || e) }); }

// components/navigation/SiteHeader.jsx
try { (() => {
/* Navigation is organised by HER PROBLEM, not by our catalogue.
   "Our Evidence" is a permanent top-level item — proof is a destination,
   not a footer link. The guarantee is a nav item, as a ghost pill. */
function SiteHeader({
  logoSrc,
  brandName = 'Evolved Elements',
  items = [],
  guaranteeLabel = '90-day guarantee',
  guaranteeHref = '#guarantee',
  ctaLabel = 'Get the pair',
  ctaHref = '#buy',
  activeHref,
  style
}) {
  return /*#__PURE__*/React.createElement("header", {
    style: {
      background: 'var(--ee-ground)',
      borderBottom: 'var(--ee-rule-w) solid var(--ee-rule)',
      ...style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--ee-container)',
      margin: '0 auto',
      padding: `var(--ee-4) var(--ee-gutter)`,
      display: 'flex',
      alignItems: 'center',
      gap: 'var(--ee-6)'
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "/",
    style: {
      display: 'flex',
      alignItems: 'center',
      flex: '0 0 auto',
      textDecoration: 'none'
    },
    "aria-label": brandName
  }, logoSrc ? /*#__PURE__*/React.createElement("img", {
    src: logoSrc,
    alt: brandName,
    style: {
      height: 34,
      width: 'auto',
      display: 'block'
    }
  }) : /*#__PURE__*/React.createElement("span", {
    style: {
      fontWeight: 'var(--ee-w-bold)',
      fontSize: 'var(--ee-h4)',
      color: 'var(--ee-ink)',
      letterSpacing: '0.06em'
    }
  }, brandName.toUpperCase())), /*#__PURE__*/React.createElement("nav", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 'var(--ee-5)',
      flexWrap: 'wrap',
      flex: 1,
      minWidth: 0
    }
  }, items.map(it => {
    const active = it.href === activeHref;
    return /*#__PURE__*/React.createElement("a", {
      key: it.href,
      href: it.href,
      "aria-current": active ? 'page' : undefined,
      style: {
        fontSize: 'var(--ee-body-s)',
        lineHeight: 1.2,
        color: 'var(--ee-ink)',
        textDecoration: 'none',
        minHeight: 'var(--ee-tap-min)',
        display: 'inline-flex',
        alignItems: 'center',
        borderBottom: active ? '2px solid var(--ee-ink)' : '2px solid transparent',
        fontWeight: active ? 'var(--ee-w-semibold)' : 'var(--ee-w-regular)'
      }
    }, it.label);
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      alignItems: 'center',
      gap: 'var(--ee-3)',
      flex: '0 0 auto'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "pill",
    href: guaranteeHref
  }, guaranteeLabel), /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "primary",
    size: "compact",
    href: ctaHref
  }, ctaLabel))));
}
Object.assign(__ds_scope, { SiteHeader });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/SiteHeader.jsx", error: String((e && e.message) || e) }); }

// components/navigation/StickyBuyBar.jsx
try { (() => {
/* Sticky buy bar appears ONLY after the mechanism section — never from page
   load. One CTA visible at a time; the secondary sits below, not beside. */
function StickyBuyBar({
  visible = false,
  productName = 'The pair — thyroid + liver',
  price,
  microline = '90-day guarantee · free shipping · cancel anytime',
  ctaLabel = 'Get the pair',
  ctaHref = '#buy',
  style
}) {
  if (!visible) return null;
  return /*#__PURE__*/React.createElement("div", {
    role: "region",
    "aria-label": "Buy",
    style: {
      position: 'sticky',
      bottom: 0,
      background: 'var(--ee-ground)',
      borderTop: 'var(--ee-border-w) solid var(--ee-border)',
      padding: `var(--ee-3) var(--ee-gutter)`,
      ...style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--ee-container)',
      margin: '0 auto',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 'var(--ee-5)',
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      minWidth: 0
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 'var(--ee-body-s)',
      fontWeight: 'var(--ee-w-semibold)',
      color: 'var(--ee-ink)'
    }
  }, productName, price && /*#__PURE__*/React.createElement(React.Fragment, null, " ", '\u00B7', " ", /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    size: "bodyS",
    weight: 600
  }, price))), /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    size: "micro",
    tone: "limit",
    style: {
      display: 'block',
      marginTop: 'var(--ee-1)'
    }
  }, microline)), /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "primary",
    href: ctaHref,
    style: {
      flex: '0 0 auto'
    }
  }, ctaLabel)));
}
Object.assign(__ds_scope, { StickyBuyBar });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/navigation/StickyBuyBar.jsx", error: String((e && e.message) || e) }); }

// components/page/HeroStack.jsx
try { (() => {
/* The above-the-fold stack.
   SIX elements, FIXED ORDER:
   eyebrow → headline → subhead → two CTAs → guarantee microline → one precise
   proof figure.
   On mobile the full stack must fit at 375x812; if it doesn't, cut the SUBHEAD —
   never the microline. */
function HeroStack({
  eyebrow,
  headline,
  subhead,
  primaryLabel = 'Get the pair',
  primaryHref = '#buy',
  secondaryLabel = 'Open the lab report for this batch',
  secondaryHref = '#report',
  microline = '90-day guarantee · free shipping · cancel anytime',
  proofFigure,
  proofLabel,
  style
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--ee-text-col)',
      display: 'grid',
      gap: 'var(--ee-5)',
      ...style
    }
  }, eyebrow && /*#__PURE__*/React.createElement(__ds_scope.Eyebrow, {
    tone: "verify"
  }, eyebrow), /*#__PURE__*/React.createElement("h1", {
    style: {
      fontSize: 'var(--ee-display)',
      lineHeight: 'var(--ee-lh-display)',
      letterSpacing: 'var(--ee-tr-display)',
      fontWeight: 'var(--ee-w-bold)',
      textWrap: 'balance',
      margin: 0
    }
  }, headline), subhead && /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 'var(--ee-lead)',
      lineHeight: 'var(--ee-lh-lead)',
      color: 'var(--ee-ink-2)',
      margin: 0
    }
  }, subhead), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--ee-4)',
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "primary",
    href: primaryHref
  }, primaryLabel), /*#__PURE__*/React.createElement(__ds_scope.Button, {
    variant: "secondary",
    href: secondaryHref
  }, secondaryLabel)), /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    size: "micro",
    tone: "limit"
  }, microline), proofFigure && /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: 'var(--ee-3)',
      borderTop: 'var(--ee-rule-w) solid var(--ee-rule)'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    size: "h3",
    weight: 600
  }, proofFigure), proofLabel && /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    size: "micro",
    tone: "limit",
    style: {
      display: 'block',
      marginTop: 'var(--ee-1)'
    }
  }, proofLabel)));
}
Object.assign(__ds_scope, { HeroStack });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/page/HeroStack.jsx", error: String((e && e.message) || e) }); }

// components/page/Section.jsx
try { (() => {
/* Page-spine section shell. Enforces the 96/64px section rhythm, the
   680/960/1200px column widths, and the "ONE quiet band per page" rule
   (the caller is responsible for using surface="quiet" only once).
   Structural, not visual. */
function Section({
  id,
  index,
  eyebrow,
  title,
  lede,
  width = 'text',
  surface = 'ground',
  children,
  style
}) {
  const widths = {
    text: 'var(--ee-text-col)',
    wide: 'var(--ee-wide-col)',
    container: 'var(--ee-container)'
  };
  const surfaces = {
    ground: 'var(--ee-ground)',
    quiet: 'var(--ee-quiet)'
  };
  return /*#__PURE__*/React.createElement("section", {
    id: id,
    "data-screen-label": index,
    style: {
      background: surfaces[surface] || surfaces.ground,
      padding: `var(--ee-section) var(--ee-gutter)`,
      ...style
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: widths[width] || widths.text,
      margin: '0 auto',
      display: 'grid',
      gap: 'var(--ee-5)'
    }
  }, (index || eyebrow) && /*#__PURE__*/React.createElement(__ds_scope.Eyebrow, null, index ? `${index}` : '', index && eyebrow ? ' \u00B7 ' : '', eyebrow || ''), title && /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 'var(--ee-h2)',
      lineHeight: 'var(--ee-lh-h2)',
      letterSpacing: 'var(--ee-tr-h2)',
      fontWeight: 'var(--ee-w-bold)',
      textWrap: 'balance',
      margin: 0,
      maxWidth: '30ch'
    }
  }, title), lede && /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 'var(--ee-lead)',
      lineHeight: 'var(--ee-lh-lead)',
      color: 'var(--ee-ink-2)',
      margin: 0,
      maxWidth: 'var(--ee-measure)'
    }
  }, lede), children));
}
Object.assign(__ds_scope, { Section });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/page/Section.jsx", error: String((e && e.message) || e) }); }

// components/proof/DisclosurePanel.jsx
try { (() => {
/* 02 · The quantified disclosure panel.
   Answers the demand that appears most often in buyer language and that the
   category refuses: how much of the active thing is in the capsule.
   It outranks every badge and must be given more space and better position
   than one. */
function DisclosurePanel({
  eyebrow = 'Per capsule',
  rows = [],
  footnote,
  surface = 'card',
  style
}) {
  return /*#__PURE__*/React.createElement(__ds_scope.VerifiableBlock, {
    surface: surface,
    style: {
      padding: 'var(--ee-4) var(--ee-5)',
      ...style
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Eyebrow, {
    style: {
      marginBottom: 'var(--ee-3)'
    }
  }, eyebrow), /*#__PURE__*/React.createElement("dl", {
    style: {
      margin: 0,
      display: 'grid',
      gridTemplateColumns: '1fr auto',
      gap: 0
    }
  }, rows.map((r, i) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: r.label
  }, /*#__PURE__*/React.createElement("dt", {
    style: {
      fontSize: 'var(--ee-body-s)',
      lineHeight: 'var(--ee-lh-body-s)',
      color: 'var(--ee-ink)',
      padding: 'var(--ee-2) var(--ee-4) var(--ee-2) 0',
      borderTop: i === 0 ? 'none' : 'var(--ee-rule-w) solid var(--ee-rule)'
    }
  }, r.label), /*#__PURE__*/React.createElement("dd", {
    style: {
      margin: 0,
      padding: 'var(--ee-2) 0',
      textAlign: 'right',
      borderTop: i === 0 ? 'none' : 'var(--ee-rule-w) solid var(--ee-rule)'
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    size: "bodyS",
    weight: 600
  }, r.value))))), footnote && /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 'var(--ee-micro)',
      lineHeight: 'var(--ee-lh-micro)',
      color: 'var(--ee-limit)',
      marginTop: 'var(--ee-3)'
    }
  }, footnote));
}
Object.assign(__ds_scope, { DisclosurePanel });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/proof/DisclosurePanel.jsx", error: String((e && e.message) || e) }); }

// components/proof/FootnotedClaim.jsx
try { (() => {
/* 04 · The footnoted claim.
   Any efficacy or superlative claim carries a marker resolving to a citation
   with its denominator visible. Marker in Verification, mono, superscript.
   Across 64 brands, exactly one substantiates a superlative with a real
   citation. Either the marker resolves to something openable, or the claim
   is deleted. */
function FootnotedClaim({
  claim,
  marker = '\u2021',
  citation,
  citationHref,
  as: Tag = 'p',
  size = 'body',
  style
}) {
  const sizes = {
    body: 'var(--ee-body)',
    h3: 'var(--ee-h3)',
    h2: 'var(--ee-h2)'
  };
  const lh = {
    body: 'var(--ee-lh-body)',
    h3: 'var(--ee-lh-h3)',
    h2: 'var(--ee-lh-h2)'
  };
  const id = `fn-${marker}-${String(claim).slice(0, 12).replace(/\W+/g, '')}`;
  return /*#__PURE__*/React.createElement("div", {
    style: style
  }, /*#__PURE__*/React.createElement(Tag, {
    style: {
      fontSize: sizes[size],
      lineHeight: lh[size],
      color: 'var(--ee-ink)',
      margin: 0,
      fontWeight: size === 'body' ? 400 : 700
    }
  }, claim, /*#__PURE__*/React.createElement("a", {
    href: `#${id}`,
    "aria-describedby": id,
    style: {
      fontFamily: 'var(--ee-font-mono)',
      color: 'var(--ee-verify)',
      verticalAlign: 'super',
      fontSize: '0.6em',
      textDecoration: 'none',
      paddingLeft: '1px'
    }
  }, marker)), /*#__PURE__*/React.createElement("p", {
    id: id,
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: 'var(--ee-micro)',
      lineHeight: 'var(--ee-lh-micro)',
      color: 'var(--ee-limit)',
      marginTop: 'var(--ee-2)'
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: 'var(--ee-verify)'
    }
  }, marker), ' ', citation, citationHref && /*#__PURE__*/React.createElement(React.Fragment, null, ' ', /*#__PURE__*/React.createElement("a", {
    href: citationHref,
    style: {
      color: 'var(--ee-verify)'
    }
  }, "Full document linked"))));
}
Object.assign(__ds_scope, { FootnotedClaim });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/proof/FootnotedClaim.jsx", error: String((e && e.message) || e) }); }

// components/proof/GuaranteeLockup.jsx
try { (() => {
/* The guarantee lockup.
   Appears in at least FOUR places, ONE length everywhere, no carve-outs,
   no asterisk. Named, and pegged to the outcome rather than to satisfaction. */
function GuaranteeLockup({
  placement = 'section',
  name = 'The 90-Day Afternoon Guarantee',
  days = '90',
  body = 'If you get to day 90 and your afternoons are unchanged, we refund the pair. Not the unopened bottle — the pair, opened, used, as intended.',
  href = '#guarantee',
  style
}) {
  /* 01 · Utility bar, every page — mono 12px, Verification on Quiet */
  if (placement === 'utility') {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        background: 'var(--ee-quiet)',
        padding: 'var(--ee-2) var(--ee-4)',
        textAlign: 'center',
        ...style
      }
    }, /*#__PURE__*/React.createElement(__ds_scope.Measured, {
      size: "label",
      tone: "verify",
      weight: 500,
      style: {
        letterSpacing: 'var(--ee-tr-label)'
      }
    }, name.toUpperCase(), " \xB7 ", /*#__PURE__*/React.createElement("a", {
      href: href,
      style: {
        color: 'var(--ee-verify)'
      }
    }, "READ IT")));
  }

  /* 03 · Microline under the hero CTA — Archivo 15px, Limit */
  if (placement === 'microline') {
    return /*#__PURE__*/React.createElement("p", {
      style: {
        fontFamily: 'var(--ee-font-mono)',
        fontSize: 'var(--ee-micro)',
        lineHeight: 'var(--ee-lh-micro)',
        color: 'var(--ee-limit)',
        margin: 0,
        ...style
      }
    }, /*#__PURE__*/React.createElement(__ds_scope.Measured, {
      tone: "limit"
    }, days, "-day"), " guarantee \xB7 free shipping \xB7 cancel anytime");
  }

  /* 04 · Its own section before the FAQ — Quiet band + 2pt left rule */
  return /*#__PURE__*/React.createElement(__ds_scope.VerifiableBlock, {
    surface: "quiet",
    style: {
      padding: 'var(--ee-6) var(--ee-7)',
      ...style
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Eyebrow, {
    style: {
      marginBottom: 'var(--ee-3)'
    }
  }, "The guarantee"), /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 'var(--ee-h2)',
      lineHeight: 'var(--ee-lh-h2)',
      letterSpacing: 'var(--ee-tr-h2)',
      fontWeight: 'var(--ee-w-bold)',
      margin: `0 0 var(--ee-4)`,
      maxWidth: '24ch'
    }
  }, name), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 'var(--ee-body)',
      lineHeight: 'var(--ee-lh-body)',
      color: 'var(--ee-ink-2)',
      maxWidth: 'var(--ee-measure)',
      margin: `0 0 var(--ee-4)`
    }
  }, body), /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    size: "micro",
    tone: "limit"
  }, "One length. ", days, " days. No carve-outs, no asterisk, no second number anywhere on this site."));
}
Object.assign(__ds_scope, { GuaranteeLockup });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/proof/GuaranteeLockup.jsx", error: String((e && e.message) || e) }); }

// components/proof/LotBlock.jsx
try { (() => {
/* 01 · The lot block.
   One brand in thirty-three assessed offers a customer-facing lot lookup.
   This is the single most differentiating module on the site — it goes above
   the fold AND in the global footer. */
function LotBlock({
  eyebrow = 'This bottle',
  lot,
  assayedBy = 'an independent laboratory',
  assayDate,
  findLotHint = 'Find the lot number on the base of your bottle.',
  reportHref = '#',
  reportLabel = "Open this batch's report →",
  surface = 'card',
  style
}) {
  return /*#__PURE__*/React.createElement(__ds_scope.VerifiableBlock, {
    surface: surface,
    style: {
      padding: 'var(--ee-4) var(--ee-5)',
      ...style
    }
  }, /*#__PURE__*/React.createElement(__ds_scope.Eyebrow, {
    style: {
      marginBottom: 'var(--ee-2)'
    }
  }, eyebrow), /*#__PURE__*/React.createElement(__ds_scope.Measured, {
    as: "div",
    size: "h3",
    weight: 600,
    style: {
      marginBottom: 'var(--ee-3)',
      letterSpacing: '0.01em'
    }
  }, "LOT ", lot), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 'var(--ee-body-s)',
      lineHeight: 'var(--ee-lh-body-s)',
      color: 'var(--ee-ink-2)',
      marginBottom: 'var(--ee-3)'
    }
  }, "Assayed by ", assayedBy, ", ", /*#__PURE__*/React.createElement(__ds_scope.Measured, null, assayDate), ". ", findLotHint), /*#__PURE__*/React.createElement("a", {
    href: reportHref,
    style: {
      fontSize: 'var(--ee-body-s)',
      fontWeight: 'var(--ee-w-semibold)',
      color: 'var(--ee-verify)'
    }
  }, reportLabel));
}
Object.assign(__ds_scope, { LotBlock });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/proof/LotBlock.jsx", error: String((e && e.message) || e) }); }

// components/proof/VerbatimQuote.jsx
try { (() => {
/* 03 · The verbatim quote block.
   Left rule is Ink, not Verification — a quote is testimony, not a document.
   Newsreader italic, attribution in mono, source always linked.
   NEVER edited, never cleaned up, never used as a product testimonial. */
function VerbatimQuote({
  quote,
  source,
  sourceHref,
  sourceLinkLabel = 'source linked',
  size = 'default',
  style
}) {
  const quoteSize = size === 'large' ? 'var(--ee-h2)' : 'var(--ee-quote)';
  return /*#__PURE__*/React.createElement("figure", {
    style: {
      margin: 0,
      ...style
    }
  }, /*#__PURE__*/React.createElement("blockquote", {
    style: {
      margin: 0,
      fontFamily: 'var(--ee-font-quote)',
      fontStyle: 'italic',
      fontWeight: 400,
      fontSize: quoteSize,
      lineHeight: 'var(--ee-lh-quote)',
      color: 'var(--ee-ink)',
      borderLeft: '2px solid var(--ee-ink)',
      paddingLeft: 'var(--ee-4)'
    }
  }, '\u201C', quote, '\u201D'), /*#__PURE__*/React.createElement("figcaption", {
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: 'var(--ee-micro)',
      lineHeight: 'var(--ee-lh-micro)',
      color: 'var(--ee-limit)',
      paddingLeft: `calc(var(--ee-4) + 2px)`,
      marginTop: 'var(--ee-3)'
    }
  }, source, sourceHref && /*#__PURE__*/React.createElement(React.Fragment, null, ' · ', /*#__PURE__*/React.createElement("a", {
    href: sourceHref,
    style: {
      color: 'var(--ee-verify)'
    }
  }, sourceLinkLabel))));
}
Object.assign(__ds_scope, { VerbatimQuote });
})(); } catch (e) { __ds_ns.__errors.push({ path: "components/proof/VerbatimQuote.jsx", error: String((e && e.message) || e) }); }

// ui_kits/amazon/ListingSlots.jsx
try { (() => {
/* Evolved Elements — packaging and Amazon listing UI kit.
   The label is the highest-stakes surface: read at arm's length under bad
   retail light, photographed for the listing, and scrutinised by a buyer who
   has been burned by labels before. */
const {
  Eyebrow,
  Measured,
  DisclosurePanel,
  MechanismDiagram,
  FootnotedClaim,
  GuaranteeLockup
} = window.EvolvedElementsDesignSystem_057731 || {};

/* Label panel — 6 elements in locked hierarchy. Rendered at 3.2x pack scale
   (1pt ≈ 3.2px here) so the 6pt / 8pt floors are checkable on screen. */
function LabelPanel({
  sku = 'thyroid'
}) {
  const S = sku === 'thyroid' ? {
    organ: 'Grass-Fed Thyroid Glandular',
    dose: '200 mg',
    count: '60 capsules',
    accent: 'var(--ee-verify)',
    serving: 'Grass-fed thyroid glandular (New Zealand)'
  } : {
    organ: 'Beef Liver',
    dose: '3,000 mg',
    count: '180 capsules',
    accent: 'var(--ee-mechanism)',
    serving: 'Beef liver (New Zealand)'
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      width: 300,
      background: 'var(--ee-ground)',
      border: 'var(--ee-border-w) solid var(--ee-border)',
      padding: 22,
      display: 'grid',
      gap: 14,
      boxSizing: 'border-box'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: "https://cdn.shopify.com/s/files/1/0799/4857/9091/files/ee-lp-logo-transparent.png",
    alt: "Evolved Elements",
    style: {
      height: 22,
      width: 'auto'
    }
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontSize: 25,
      lineHeight: 1.08,
      letterSpacing: '-0.01em',
      fontWeight: 700,
      margin: 0,
      color: 'var(--ee-ink)'
    }
  }, S.organ), /*#__PURE__*/React.createElement(Measured, {
    size: "bodyS",
    weight: 600,
    style: {
      display: 'block',
      marginTop: 6
    }
  }, S.dose, " \xB7 ", S.count)), /*#__PURE__*/React.createElement("div", {
    style: {
      borderLeft: `var(--ee-verify-rule) solid ${S.accent}`,
      paddingLeft: 10
    }
  }, /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    weight: 500,
    style: {
      letterSpacing: '0.08em'
    }
  }, "SINGLE-SOURCE NEW ZEALAND")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 15,
      lineHeight: 1.4,
      color: 'var(--ee-ink)',
      fontWeight: 500
    }
  }, "No fillers. No magnesium stearate."), /*#__PURE__*/React.createElement("table", {
    style: {
      width: '100%',
      borderCollapse: 'collapse',
      border: '1px solid var(--ee-ink)',
      fontFamily: 'var(--ee-font-mono)'
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: "2",
    style: {
      borderBottom: '3px solid var(--ee-ink)',
      padding: '4px 6px',
      fontSize: 13,
      fontWeight: 700
    }
  }, "Supplement Facts")), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    colSpan: "2",
    style: {
      borderBottom: '1px solid var(--ee-ink)',
      padding: '3px 6px',
      fontSize: 11
    }
  }, "Serving size 1 capsule \xB7 Servings per container ", S.count.split(' ')[0])), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '3px 6px',
      fontSize: 11
    }
  }, S.serving), /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '3px 6px',
      fontSize: 11,
      textAlign: 'right'
    }
  }, S.dose)), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      borderTop: '1px solid var(--ee-ink)',
      padding: '3px 6px',
      fontSize: 11
    }
  }, "Other ingredients"), /*#__PURE__*/React.createElement("td", {
    style: {
      borderTop: '1px solid var(--ee-ink)',
      padding: '3px 6px',
      fontSize: 11,
      textAlign: 'right'
    }
  }, "none")))), /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: 'var(--ee-rule-w) solid var(--ee-rule)',
      paddingTop: 10,
      display: 'flex',
      justifyContent: 'space-between',
      gap: 12
    }
  }, /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    weight: 600
  }, "LOT 2609-NZ"), /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "limit"
  }, "EXP 08/2028")), /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "limit",
    style: {
      lineHeight: 1.4
    }
  }, "Look up this lot's assay at evolvedelements.com/evidence"));
}

/* The seven Amazon listing image slots. Minimum type is 42px at 2000×2000 —
   assume she is viewing on a phone at thumbnail scale first. */
const SLOTS = [{
  n: '01',
  title: 'Main image — product on pure white',
  rule: 'Platform requirement. The only place white ground is permitted.',
  white: true
}, {
  n: '02',
  title: 'The quantified disclosure panel',
  rule: 'Per-capsule numbers, mono, large. The slot that answers her real question.',
  kind: 'disclosure'
}, {
  n: '03',
  title: 'The two-site diagram',
  rule: 'Vertical variant, Ground background, limit line included.',
  kind: 'mechanism'
}, {
  n: '04',
  title: 'Single origin + lot lookup',
  rule: 'Photograph of the certificate with the lookup instruction.',
  kind: 'origin'
}, {
  n: '05',
  title: 'Register-B lifestyle',
  rule: 'Woman 48–58, her kitchen, available light.',
  kind: 'life'
}, {
  n: '06',
  title: 'The guarantee',
  rule: 'Named, outcome-pegged, one length.',
  kind: 'guarantee'
}, {
  n: '07',
  title: 'Comparison',
  rule: 'Including the row we lose on purpose.',
  kind: 'comparison'
}];
function Slot({
  slot
}) {
  const size = 300;
  const frame = {
    width: size,
    height: size,
    boxSizing: 'border-box',
    background: slot.white ? '#FFFFFF' : 'var(--ee-ground)',
    border: 'var(--ee-rule-w) solid var(--ee-rule)',
    padding: 18,
    overflow: 'hidden',
    display: 'grid'
  };
  let body;
  if (slot.white) {
    body = /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'grid',
        placeItems: 'center',
        border: '2px dashed var(--ee-border)'
      }
    }, /*#__PURE__*/React.createElement(Measured, {
      size: "micro",
      tone: "limit",
      style: {
        textAlign: 'center',
        lineHeight: 1.5,
        padding: 12
      }
    }, "NO PRODUCT PHOTOGRAPHY SUPPLIED", /*#__PURE__*/React.createElement("br", null), "Both bottles, pure white ground"));
  } else if (slot.kind === 'disclosure') {
    body = /*#__PURE__*/React.createElement("div", {
      style: {
        alignSelf: 'center'
      }
    }, /*#__PURE__*/React.createElement(DisclosurePanel, {
      surface: "card",
      rows: [{
        label: 'Grass-fed thyroid glandular, New Zealand',
        value: '200 mg'
      }, {
        label: 'Excipients',
        value: 'none'
      }, {
        label: 'Capsules per bottle',
        value: '60'
      }]
    }));
  } else if (slot.kind === 'mechanism') {
    body = /*#__PURE__*/React.createElement("div", {
      style: {
        transform: 'scale(.72)',
        transformOrigin: 'top left',
        width: '139%'
      }
    }, /*#__PURE__*/React.createElement(MechanismDiagram, {
      orientation: "vertical",
      eyebrow: null,
      limitLine: "The exact share of conversion the liver performs is still argued over in the literature."
    }));
  } else if (slot.kind === 'origin') {
    body = /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'grid',
        gridTemplateRows: '1fr auto',
        gap: 12
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        background: 'var(--ee-deep)',
        border: '2px dashed var(--ee-border)',
        display: 'grid',
        placeItems: 'center',
        padding: 10
      }
    }, /*#__PURE__*/React.createElement(Measured, {
      size: "micro",
      tone: "limit",
      style: {
        textAlign: 'center',
        lineHeight: 1.5
      }
    }, "REGISTER A \xB7 NO IMAGE", /*#__PURE__*/React.createElement("br", null), "Certificate of origin, tight crop")), /*#__PURE__*/React.createElement("div", {
      style: {
        borderLeft: 'var(--ee-verify-rule) solid var(--ee-verify)',
        paddingLeft: 10
      }
    }, /*#__PURE__*/React.createElement(Measured, {
      size: "micro",
      weight: 600,
      style: {
        display: 'block'
      }
    }, "SINGLE-SOURCE NEW ZEALAND"), /*#__PURE__*/React.createElement(Measured, {
      size: "micro",
      tone: "limit",
      style: {
        display: 'block'
      }
    }, "LOT 2609-NZ \xB7 LOOK IT UP")));
  } else if (slot.kind === 'life') {
    body = /*#__PURE__*/React.createElement("div", {
      style: {
        background: 'var(--ee-deep)',
        border: '2px dashed var(--ee-border)',
        display: 'grid',
        placeItems: 'center',
        padding: 14
      }
    }, /*#__PURE__*/React.createElement(Measured, {
      size: "micro",
      tone: "limit",
      style: {
        textAlign: 'center',
        lineHeight: 1.5
      }
    }, "REGISTER B \xB7 NO IMAGE SUPPLIED", /*#__PURE__*/React.createElement("br", null), "A woman visibly 48\u201358 in her own kitchen, available light, composed \u2014 not delighted. Never a model under 45."));
  } else if (slot.kind === 'guarantee') {
    body = /*#__PURE__*/React.createElement("div", {
      style: {
        alignSelf: 'center',
        borderLeft: 'var(--ee-verify-rule) solid var(--ee-verify)',
        background: 'var(--ee-quiet)',
        padding: 16
      }
    }, /*#__PURE__*/React.createElement(Eyebrow, {
      style: {
        marginBottom: 8
      }
    }, "The guarantee"), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 22,
        lineHeight: 1.12,
        fontWeight: 700,
        marginBottom: 8
      }
    }, "The 90-Day Afternoon Guarantee"), /*#__PURE__*/React.createElement(Measured, {
      size: "micro",
      tone: "ink2",
      style: {
        lineHeight: 1.45
      }
    }, "Day 90 and your afternoons unchanged \u2014 we refund the pair, opened and used. One length. No carve-outs."));
  } else {
    body = /*#__PURE__*/React.createElement("div", {
      style: {
        alignSelf: 'center'
      }
    }, /*#__PURE__*/React.createElement("table", {
      style: {
        width: '100%',
        borderCollapse: 'collapse',
        fontFamily: 'var(--ee-font-mono)',
        fontSize: 12
      }
    }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
      style: {
        background: 'var(--ee-deep)'
      }
    }, ['', 'US', 'THEM'].map((h, i) => /*#__PURE__*/React.createElement("th", {
      key: i,
      style: {
        padding: '5px 6px',
        textAlign: i ? 'right' : 'left',
        fontSize: 10,
        letterSpacing: '0.1em'
      }
    }, h)))), /*#__PURE__*/React.createElement("tbody", null, [['Dose published', '200 mg', 'no'], ['Lot report', 'yes', 'no'], ['Named origin', 'NZ', 'no'], ['Price / month', '$68', '$29']].map((r, i) => /*#__PURE__*/React.createElement("tr", {
      key: r[0],
      style: {
        borderBottom: '1px solid var(--ee-rule)',
        background: i === 3 ? 'var(--ee-quiet)' : 'transparent'
      }
    }, /*#__PURE__*/React.createElement("td", {
      style: {
        padding: '5px 6px'
      }
    }, r[0], i === 3 && /*#__PURE__*/React.createElement("span", {
      style: {
        display: 'block',
        fontSize: 9,
        color: 'var(--ee-limit)',
        letterSpacing: '0.1em'
      }
    }, "THE ROW WE LOSE")), /*#__PURE__*/React.createElement("td", {
      style: {
        padding: '5px 6px',
        textAlign: 'right',
        fontWeight: 600
      }
    }, r[1]), /*#__PURE__*/React.createElement("td", {
      style: {
        padding: '5px 6px',
        textAlign: 'right',
        color: 'var(--ee-limit)'
      }
    }, r[2]))))));
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 8
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: frame
  }, body), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    weight: 600,
    style: {
      display: 'block'
    }
  }, slot.n, " \xB7 ", slot.title), /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "limit",
    style: {
      display: 'block',
      lineHeight: 1.4
    }
  }, slot.rule)));
}
Object.assign(window, {
  LabelPanel,
  Slot,
  SLOTS
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/amazon/ListingSlots.jsx", error: String((e && e.message) || e) }); }

// ui_kits/email/EmailTemplates.jsx
try { (() => {
/* Evolved Elements — email UI kit.
   600px, single column only. Background is #FAF7F2, never white.
   Assume images are blocked: the email must read with none loaded.
   Email-safe fallbacks: Archivo → Helvetica, Arial · IBM Plex Mono → Courier New
   · Newsreader → Georgia, serif. */
const {
  Measured
} = window.EvolvedElementsDesignSystem_057731 || {};
const PROSE = "Archivo, Helvetica, Arial, sans-serif";
const MONO = "'IBM Plex Mono', 'Courier New', monospace";
const QUOTE = "Newsreader, Georgia, serif";
function pal(inverse) {
  return inverse ? {
    ground: '#14100D',
    quiet: '#221C17',
    ink: '#F4F0E9',
    ink2: '#CFC7BC',
    limit: '#948B80',
    verify: '#5FBFB4',
    rule: '#2E332F',
    border: '#5C554D',
    btnLabel: '#14100D'
  } : {
    ground: '#FAF7F2',
    quiet: '#F0EAE0',
    ink: '#1A1714',
    ink2: '#463F38',
    limit: '#6B6560',
    verify: '#0E5A57',
    rule: '#D8D2C6',
    border: '#8E8375',
    btnLabel: '#FAF7F2'
  };
}

/* Bulletproof-style button, 44px minimum height. */
function EmailButton({
  label,
  c
}) {
  return /*#__PURE__*/React.createElement("table", {
    role: "presentation",
    cellPadding: "0",
    cellSpacing: "0",
    border: "0",
    style: {
      borderCollapse: 'collapse'
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      background: c.verify,
      borderRadius: 999,
      padding: '14px 28px',
      minHeight: 44
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    style: {
      fontFamily: PROSE,
      fontSize: 17,
      fontWeight: 600,
      color: c.btnLabel,
      textDecoration: 'none',
      lineHeight: '1.2'
    }
  }, label)))));
}

/* "Lot 2609-NZ is up." Mono subject line with the lot number, one paragraph,
   one link to the report. No competitor can send it. */
function LotEmail({
  inverse = false
}) {
  const c = pal(inverse);
  return /*#__PURE__*/React.createElement("div", {
    style: {
      background: inverse ? '#0B0907' : '#EFE9E1',
      padding: 24
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: 600,
      maxWidth: '100%',
      margin: '0 auto 12px',
      fontFamily: MONO,
      fontSize: 15,
      color: c.limit
    }
  }, "SUBJECT \u2014 ", /*#__PURE__*/React.createElement("span", {
    style: {
      color: c.ink
    }
  }, "Lot 2609-NZ is up.")), /*#__PURE__*/React.createElement("table", {
    role: "presentation",
    width: "600",
    cellPadding: "0",
    cellSpacing: "0",
    border: "0",
    style: {
      width: 600,
      maxWidth: '100%',
      margin: '0 auto',
      background: c.ground,
      borderCollapse: 'collapse'
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '16px 32px',
      background: c.quiet,
      borderBottom: `1px solid ${c.rule}`
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: MONO,
      fontSize: 15,
      color: c.verify
    }
  }, "THE 90-DAY AFTERNOON GUARANTEE"))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '28px 32px 0'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: inverse ? '../../assets/logo/evolved-elements-lockup-inverse.png' : 'https://cdn.shopify.com/s/files/1/0799/4857/9091/files/ee-lp-logo-transparent.png',
    alt: "Evolved Elements",
    width: "180",
    style: {
      display: 'block',
      width: 180,
      height: 'auto'
    }
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '24px 32px 0'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: MONO,
      fontSize: 15,
      letterSpacing: '0.12em',
      color: c.limit,
      marginBottom: 12
    }
  }, "LOT 2609-NZ \xB7 12 AUG 2026"), /*#__PURE__*/React.createElement("h1", {
    style: {
      fontFamily: PROSE,
      fontSize: 30,
      lineHeight: 1.12,
      letterSpacing: '-0.015em',
      fontWeight: 700,
      color: c.ink,
      margin: 0
    }
  }, "The assay for the batch shipping this week is published."))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '20px 32px 0'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: PROSE,
      fontSize: 17,
      lineHeight: 1.65,
      color: c.ink,
      margin: 0
    }
  }, "Content per capsule measured at 201.4 mg against a 200 mg label claim, specification 190\u2013210 mg. Heavy metals and microbials are on page 2. If you are holding a bottle from an earlier batch, its report has not moved \u2014 every lot we have shipped is still on the evidence page."))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '24px 32px 0'
    }
  }, /*#__PURE__*/React.createElement("table", {
    role: "presentation",
    width: "100%",
    cellPadding: "0",
    cellSpacing: "0",
    border: "0",
    style: {
      borderCollapse: 'collapse'
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    width: "2",
    style: {
      background: c.verify,
      width: 2
    }
  }), /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '12px 16px',
      background: inverse ? c.quiet : '#FFFFFF'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: MONO,
      fontSize: 15,
      color: c.limit,
      marginBottom: 4
    }
  }, "THIS BOTTLE"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: MONO,
      fontSize: 20,
      fontWeight: 600,
      color: c.ink,
      marginBottom: 6
    }
  }, "LOT 2609-NZ"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: MONO,
      fontSize: 15,
      lineHeight: 1.5,
      color: c.ink2
    }
  }, "Grass-fed thyroid glandular, New Zealand \xB7 200 mg \xB7 60 ct \xB7 excipients none"))))))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '24px 32px 0'
    }
  }, /*#__PURE__*/React.createElement(EmailButton, {
    label: "Open the report",
    c: c
  }))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '12px 32px 0'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: MONO,
      fontSize: 15,
      color: c.limit
    }
  }, "90-day guarantee \xB7 free shipping \xB7 cancel anytime"))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '28px 32px 0'
    }
  }, /*#__PURE__*/React.createElement("table", {
    role: "presentation",
    width: "100%",
    cellPadding: "0",
    cellSpacing: "0",
    border: "0",
    style: {
      borderCollapse: 'collapse'
    }
  }, /*#__PURE__*/React.createElement("tbody", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    width: "2",
    style: {
      background: c.ink,
      width: 2
    }
  }), /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '0 0 0 16px'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: QUOTE,
      fontStyle: 'italic',
      fontSize: 20,
      lineHeight: 1.42,
      color: c.ink,
      margin: 0
    }
  }, '\u201C', "they say they are ok ! I tell them I am not", '\u201D'), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: MONO,
      fontSize: 15,
      color: c.limit,
      margin: '10px 0 0'
    }
  }, "HealthUnlocked / ThyroidUK \xB7 user Spam1 \xB7 ", /*#__PURE__*/React.createElement("a", {
    href: "#",
    style: {
      color: c.verify
    }
  }, "source linked")))))))), /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("td", {
    style: {
      padding: '28px 32px 32px'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      borderTop: `1px solid ${c.rule}`,
      paddingTop: 16
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: MONO,
      fontSize: 15,
      lineHeight: 1.5,
      color: c.limit,
      margin: 0
    }
  }, "Bathing Evolved LLC \xB7 Evolved Elements", /*#__PURE__*/React.createElement("br", null), "You are receiving this because you asked for each lot report.", ' ', /*#__PURE__*/React.createElement("a", {
    href: "#",
    style: {
      color: c.verify
    }
  }, "Unsubscribe"), " \u2014 one click, no questions."), /*#__PURE__*/React.createElement("p", {
    style: {
      fontFamily: MONO,
      fontSize: 15,
      lineHeight: 1.5,
      color: c.limit,
      margin: '12px 0 0'
    }
  }, "These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure or prevent any disease.")))))));
}

/* Organic social — three post types, and no others. */
function OrganicCard({
  type
}) {
  const base = {
    background: 'var(--ee-ground)',
    boxSizing: 'border-box',
    border: 'var(--ee-rule-w) solid var(--ee-rule)'
  };
  if (type === 'quote') {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        ...base,
        width: 324,
        height: 405,
        padding: 28,
        display: 'grid',
        gridTemplateRows: '1fr auto'
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        display: 'grid',
        alignContent: 'center'
      }
    }, /*#__PURE__*/React.createElement("blockquote", {
      style: {
        margin: 0,
        fontFamily: 'var(--ee-font-quote)',
        fontStyle: 'italic',
        fontSize: 26,
        lineHeight: 1.3,
        color: 'var(--ee-ink)',
        borderLeft: '2px solid var(--ee-ink)',
        paddingLeft: 16
      }
    }, '\u201C', "I could sleep 10 hours and still wake up tired", '\u201D')), /*#__PURE__*/React.createElement("div", {
      style: {
        fontFamily: 'var(--ee-font-mono)',
        fontSize: 11,
        letterSpacing: '0.1em',
        color: 'var(--ee-limit)'
      }
    }, "THYROIDUK \xB7 1 OF 263 QUOTES COLLECTED"));
  }
  if (type === 'document') {
    return /*#__PURE__*/React.createElement("div", {
      style: {
        ...base,
        width: 324,
        height: 324,
        padding: 24,
        display: 'grid',
        gridTemplateRows: '1fr auto',
        gap: 16
      }
    }, /*#__PURE__*/React.createElement("div", {
      style: {
        background: 'var(--ee-deep)',
        border: '2px dashed var(--ee-border)',
        display: 'grid',
        placeItems: 'center',
        padding: 16,
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontFamily: 'var(--ee-font-mono)',
        fontSize: 11,
        lineHeight: 1.5,
        color: 'var(--ee-limit)'
      }
    }, "REGISTER A \xB7 NO IMAGE SUPPLIED", /*#__PURE__*/React.createElement("br", null), "A real page from a real report, cropped tight")), /*#__PURE__*/React.createElement("div", {
      style: {
        fontFamily: 'var(--ee-font-mono)',
        fontSize: 12,
        lineHeight: 1.4,
        color: 'var(--ee-ink)'
      }
    }, "CERTIFICATE OF ANALYSIS \xB7 LOT 2609-NZ \xB7 12 AUG 2026"));
  }
  return /*#__PURE__*/React.createElement("div", {
    style: {
      ...base,
      width: 324,
      height: 405,
      padding: 28,
      display: 'grid',
      gridTemplateRows: 'auto 1fr auto',
      gap: 16
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      fontFamily: 'var(--ee-font-mono)',
      fontSize: 11,
      letterSpacing: '0.1em',
      color: 'var(--ee-limit)'
    }
  }, /*#__PURE__*/React.createElement("span", null, "EXPLAINER"), /*#__PURE__*/React.createElement("span", null, "01 / 06")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      alignContent: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 28,
      lineHeight: 1.1,
      letterSpacing: '-0.015em',
      fontWeight: 700,
      color: 'var(--ee-ink)'
    }
  }, "Why did raising the dose change nothing?")), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: 11,
      lineHeight: 1.5,
      color: 'var(--ee-limit)',
      borderTop: 'var(--ee-rule-w) solid var(--ee-rule)',
      paddingTop: 12
    }
  }, "FRAME 6 CARRIES THE LIMIT LINE. MAX 6 FRAMES."));
}
Object.assign(window, {
  LotEmail,
  OrganicCard,
  EmailButton,
  pal
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/email/EmailTemplates.jsx", error: String((e && e.message) || e) }); }

// ui_kits/kit-guard.js
try { (() => {
/* Shared guard for every Evolved Elements UI kit.
   The design-system bundle (_ds_bundle.js) is generated by the compiler. If the
   page is opened before a compile has run, say so plainly instead of rendering
   a blank screen. */
(function () {
  var NS = 'EvolvedElementsDesignSystem_057731';
  window.EE_NS = NS;
  window.EE_READY = !!window[NS];
  if (window.EE_READY) return;
  document.addEventListener('DOMContentLoaded', function () {
    var root = document.getElementById('root');
    if (!root || root.childElementCount) return;
    root.innerHTML = '<div style="max-width:680px;margin:96px auto;padding:0 24px;font-family:var(--ee-font-prose);color:var(--ee-ink)">' + '<div style="font-family:var(--ee-font-mono);font-size:12px;letter-spacing:.12em;color:var(--ee-limit);margin-bottom:12px">DESIGN SYSTEM BUNDLE NOT COMPILED</div>' + '<h1 style="font-size:36px;line-height:1.1;letter-spacing:-.015em;margin:0 0 16px">This kit needs <code style="font-family:var(--ee-font-mono);font-size:.8em">_ds_bundle.js</code>.</h1>' + '<p style="font-size:19px;line-height:1.68;color:var(--ee-ink-2);margin:0">The bundle is generated automatically when the design system compiles. ' + 'Reload this page once a compile has run and the kit will render.</p></div>';
  });
})();
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/kit-guard.js", error: String((e && e.message) || e) }); }

// ui_kits/paid_social/Artboards.jsx
try { (() => {
/* Evolved Elements — paid social UI kit.
   Five artboards. Three permitted layouts. Nothing else ships.
   Text occupies no more than 40% of the frame. One idea per creative. */
const {
  Eyebrow,
  Measured,
  VerbatimQuote,
  DisclosurePanel,
  MechanismDiagram
} = window.EvolvedElementsDesignSystem_057731 || {};
const LOGO = 'https://cdn.shopify.com/s/files/1/0799/4857/9091/files/ee-lp-logo-transparent.png';
const LOGO_INVERSE = '../../assets/logo/evolved-elements-lockup-inverse.png';

/* Locked artboard specs, transcribed from Part 07 Surface B. */
const ARTBOARDS = {
  square: {
    w: 1080,
    h: 1080,
    margin: 60,
    headline: 78,
    body: 38,
    min: 30,
    label: 'Meta / Instagram feed'
  },
  portrait: {
    w: 1080,
    h: 1350,
    margin: 60,
    headline: 84,
    body: 40,
    min: 30,
    label: 'Meta feed, best real estate'
  },
  story: {
    w: 1080,
    h: 1920,
    margin: 72,
    headline: 96,
    body: 42,
    min: 34,
    label: 'Stories / Reels',
    safeTop: 250,
    safeBottom: 320
  },
  wide: {
    w: 1200,
    h: 628,
    margin: 48,
    headline: 58,
    body: 30,
    min: 26,
    label: 'Static display / link preview'
  },
  instream: {
    w: 1080,
    h: 608,
    margin: 48,
    headline: 58,
    body: 30,
    min: 26,
    label: 'In-stream video still'
  }
};

/* An artboard frame: real pixel dimensions, scaled for display only. */
function Artboard({
  spec,
  scale = 0.34,
  inverse = false,
  showSafe = false,
  children
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--ee-2)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      width: spec.w * scale,
      height: spec.h * scale,
      overflow: 'hidden',
      border: 'var(--ee-rule-w) solid var(--ee-rule)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    "data-ee-theme": inverse ? 'inverse' : undefined,
    style: {
      width: spec.w,
      height: spec.h,
      transform: `scale(${scale})`,
      transformOrigin: 'top left',
      background: inverse ? '#14100D' : 'var(--ee-ground)',
      position: 'relative',
      boxSizing: 'border-box',
      padding: spec.margin,
      display: 'grid'
    }
  }, showSafe && spec.safeTop && /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      inset: 0,
      pointerEvents: 'none'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: 0,
      right: 0,
      top: spec.safeTop,
      borderTop: '3px dashed var(--ee-border)'
    }
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      position: 'absolute',
      left: 0,
      right: 0,
      bottom: spec.safeBottom,
      borderTop: '3px dashed var(--ee-border)'
    }
  })), children)), /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "limit"
  }, spec.w, " \xD7 ", spec.h, " \xB7 ", spec.label, " \xB7 margin ", spec.margin, " \xB7 min ", spec.min));
}

/* The logo sits bottom-left at 48px height minimum, never centred, never over an image. */
function AdLogo({
  spec,
  inverse
}) {
  return /*#__PURE__*/React.createElement("img", {
    src: inverse ? LOGO_INVERSE : LOGO,
    alt: "Evolved Elements",
    style: {
      height: Math.max(48, spec.h * 0.045),
      width: 'auto',
      alignSelf: 'end',
      justifySelf: 'start'
    }
  });
}

/* LAYOUT 01 · Her sentence — cold audiences, the recognition entry. No product. */
function HerSentence({
  spec,
  inverse,
  showSafe
}) {
  const pad = spec.safeTop ? {
    paddingTop: spec.safeTop,
    paddingBottom: spec.safeBottom
  } : {};
  return /*#__PURE__*/React.createElement(Artboard, {
    spec: spec,
    inverse: inverse,
    showSafe: showSafe
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateRows: '1fr auto',
      gap: spec.margin,
      ...pad
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      alignContent: 'center',
      gap: spec.margin * 0.6
    }
  }, /*#__PURE__*/React.createElement("blockquote", {
    style: {
      margin: 0,
      fontFamily: 'var(--ee-font-quote)',
      fontStyle: 'italic',
      fontWeight: 400,
      fontSize: spec.headline * 0.82,
      lineHeight: 1.24,
      color: 'var(--ee-ink)',
      borderLeft: '10px solid var(--ee-ink)',
      paddingLeft: spec.margin * 0.7
    }
  }, '\u201C', "they say they are ok ! I tell them I am not", '\u201D'), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: spec.min * 1.15,
      color: 'var(--ee-limit)',
      paddingLeft: spec.margin * 0.7 + 10
    }
  }, "HEALTHUNLOCKED / THYROIDUK \xB7 USER SPAM1 \xB7 1 OF 263 QUOTES COLLECTED")), /*#__PURE__*/React.createElement(AdLogo, {
    spec: spec,
    inverse: inverse
  })));
}

/* LAYOUT 02 · The document — mid-funnel, sceptic-facing.
   Register-A photograph + one mono overline + one Archivo line. */
function TheDocument({
  spec,
  inverse,
  showSafe
}) {
  const pad = spec.safeTop ? {
    paddingTop: spec.safeTop,
    paddingBottom: spec.safeBottom
  } : {};
  return /*#__PURE__*/React.createElement(Artboard, {
    spec: spec,
    inverse: inverse,
    showSafe: showSafe
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateRows: 'auto 1fr auto',
      gap: spec.margin * 0.6,
      ...pad
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: spec.min * 1.2,
      letterSpacing: '0.12em',
      color: 'var(--ee-verify)',
      fontWeight: 500
    }
  }, "LOT 2609-NZ \xB7 ASSAY PUBLISHED 12 AUG 2026"), /*#__PURE__*/React.createElement("div", {
    style: {
      background: inverse ? '#221C17' : 'var(--ee-deep)',
      border: `4px dashed var(--ee-border)`,
      display: 'grid',
      placeItems: 'center',
      padding: spec.margin * 0.5,
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: spec.min,
      lineHeight: 1.5,
      color: 'var(--ee-limit)',
      maxWidth: '32ch'
    }
  }, "REGISTER A \xB7 NO IMAGE SUPPLIED", /*#__PURE__*/React.createElement("br", null), "The lot report on a desk, or capsule contents weighed with the number legible. Flat top-down, available light, tight crop.")), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: spec.margin * 0.4
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: spec.headline * 0.62,
      lineHeight: 1.06,
      letterSpacing: '-0.02em',
      fontWeight: 700,
      color: 'var(--ee-ink)',
      textWrap: 'balance'
    }
  }, "201.4 mg measured against a 200 mg label claim."), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: spec.min * 1.1,
      color: 'var(--ee-limit)'
    }
  }, "90-DAY GUARANTEE \xB7 ONE LENGTH, NO CARVE-OUTS"), /*#__PURE__*/React.createElement(AdLogo, {
    spec: spec,
    inverse: inverse
  }))));
}

/* LAYOUT 03 · The pair — retargeting and conversion.
   Both SKUs on Ground, two-node diagram reduced, price and guarantee in mono. */
function ThePair({
  spec,
  inverse,
  showSafe
}) {
  const pad = spec.safeTop ? {
    paddingTop: spec.safeTop,
    paddingBottom: spec.safeBottom
  } : {};
  const stacked = spec.h / spec.w > 1.1;
  return /*#__PURE__*/React.createElement(Artboard, {
    spec: spec,
    inverse: inverse,
    showSafe: showSafe
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateRows: 'auto auto 1fr auto',
      gap: spec.margin * 0.5,
      ...pad
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: spec.min * 1.2,
      letterSpacing: '0.12em',
      color: 'var(--ee-limit)',
      fontWeight: 500
    }
  }, "TWO SITES \xB7 TWO BOTTLES \xB7 ONE PATHWAY"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: spec.headline * 0.6,
      lineHeight: 1.06,
      letterSpacing: '-0.02em',
      fontWeight: 700,
      color: 'var(--ee-ink)',
      textWrap: 'balance'
    }
  }, "The gland makes it. The liver activates it."), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: stacked ? '1fr' : '1fr 1fr',
      gap: spec.margin * 0.5,
      alignContent: 'start'
    }
  }, [['01', 'Thyroid glandular', '200 mg · 60 ct', 'var(--ee-verify)'], ['02', 'Beef liver gentle', '3,000 mg · 180 ct', 'var(--ee-mechanism)']].map(([n, name, dose, c]) => /*#__PURE__*/React.createElement("div", {
    key: n,
    style: {
      borderLeft: `10px solid ${c}`,
      paddingLeft: spec.margin * 0.45,
      display: 'grid',
      gap: spec.min * 0.25,
      alignContent: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: spec.min * 1.05,
      color: c,
      fontWeight: 600,
      letterSpacing: '0.12em'
    }
  }, "SITE ", n), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: spec.body * 0.95,
      fontWeight: 600,
      color: 'var(--ee-ink)',
      lineHeight: 1.2
    }
  }, name), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: spec.min * 1.1,
      color: 'var(--ee-ink-2)'
    }
  }, dose)))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: spec.min * 0.5
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: spec.min * 1.25,
      color: 'var(--ee-ink)',
      fontWeight: 600
    }
  }, "$68.00 / MONTH \xB7 90-DAY GUARANTEE"), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: spec.min,
      color: 'var(--ee-limit)',
      lineHeight: 1.45
    }
  }, "The exact share of conversion the liver performs is still argued over in the literature."), /*#__PURE__*/React.createElement(AdLogo, {
    spec: spec,
    inverse: inverse
  }))));
}
const LAYOUTS = {
  'Her sentence': {
    Component: HerSentence,
    when: 'Cold audiences. The recognition entry.',
    construction: 'Verbatim quote in Newsreader italic, near-headline scale, on Ground. Mono attribution beneath. No product.'
  },
  'The document': {
    Component: TheDocument,
    when: 'Mid-funnel, sceptic-facing.',
    construction: 'Register-A photograph of the lot report or weighed capsule contents, one mono overline, one Archivo line.'
  },
  'The pair': {
    Component: ThePair,
    when: 'Retargeting and conversion.',
    construction: 'Both SKUs on Ground, two-node diagram reduced, price and guarantee in mono.'
  }
};
Object.assign(window, {
  ARTBOARDS,
  LAYOUTS,
  Artboard,
  HerSentence,
  TheDocument,
  ThePair
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/paid_social/Artboards.jsx", error: String((e && e.message) || e) }); }

// ui_kits/web/EvidencePage.jsx
try { (() => {
/* Evolved Elements — web UI kit · "Our Evidence".
   Proof is a destination, not a footer link. This is the page that
   permanent top-level nav item goes to: the lot archive. */
const {
  Section,
  Eyebrow,
  Measured,
  Button,
  VerifiableBlock,
  LotBlock,
  DisclosurePanel,
  FootnotedClaim,
  ProofChart
} = window.EvolvedElementsDesignSystem_057731 || {};
const LOT_ARCHIVE = [{
  lot: '2609-NZ',
  assay: '12 Aug 2026',
  sku: 'Thyroid glandular',
  dose: '200 mg',
  origin: 'New Zealand',
  current: true
}, {
  lot: '2609-NZ-L',
  assay: '12 Aug 2026',
  sku: 'Beef liver gentle',
  dose: '3,000 mg',
  origin: 'New Zealand',
  current: true
}, {
  lot: '2604-NZ',
  assay: '19 Apr 2026',
  sku: 'Thyroid glandular',
  dose: '200 mg',
  origin: 'New Zealand'
}, {
  lot: '2604-NZ-L',
  assay: '19 Apr 2026',
  sku: 'Beef liver gentle',
  dose: '3,000 mg',
  origin: 'New Zealand'
}, {
  lot: '2512-NZ',
  assay: '04 Dec 2025',
  sku: 'Thyroid glandular',
  dose: '200 mg',
  origin: 'New Zealand'
}];
function EvidencePage({
  go
}) {
  const [filter, setFilter] = React.useState('All');
  const skus = ['All', 'Thyroid glandular', 'Beef liver gentle'];
  const rows = LOT_ARCHIVE.filter(r => filter === 'All' || r.sku === filter);
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Section, {
    id: "evidence",
    index: "Our Evidence",
    eyebrow: "Every lot, every assay",
    width: "wide",
    title: "Every batch we have shipped, and the report for each one",
    lede: "No lot is removed from this page. A brand whose position is disclosure cannot have an archive with gaps in it."
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--ee-2)',
      flexWrap: 'wrap'
    }
  }, skus.map(s => /*#__PURE__*/React.createElement(Button, {
    key: s,
    variant: filter === s ? 'primary' : 'secondary',
    size: "compact",
    onClick: () => setFilter(s)
  }, s))), /*#__PURE__*/React.createElement("div", {
    style: {
      overflowX: 'auto'
    }
  }, /*#__PURE__*/React.createElement("table", {
    style: {
      width: '100%',
      borderCollapse: 'collapse',
      minWidth: 620
    }
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    style: {
      background: 'var(--ee-deep)'
    }
  }, ['LOT', 'SKU', 'PER CAPSULE', 'ORIGIN', 'ASSAY PUBLISHED', 'REPORT'].map((h, i) => /*#__PURE__*/React.createElement("th", {
    key: h,
    scope: "col",
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: 'var(--ee-label)',
      letterSpacing: 'var(--ee-tr-label)',
      fontWeight: 500,
      textAlign: i > 1 ? 'right' : 'left',
      padding: 'var(--ee-3) var(--ee-4)'
    }
  }, h)))), /*#__PURE__*/React.createElement("tbody", null, rows.map(r => /*#__PURE__*/React.createElement("tr", {
    key: r.lot,
    style: {
      borderBottom: 'var(--ee-rule-w) solid var(--ee-rule)'
    }
  }, /*#__PURE__*/React.createElement("th", {
    scope: "row",
    style: {
      textAlign: 'left',
      padding: 'var(--ee-3) var(--ee-4)',
      fontWeight: 400
    }
  }, /*#__PURE__*/React.createElement(Measured, {
    size: "bodyS",
    weight: 600
  }, r.lot), r.current && /*#__PURE__*/React.createElement(Measured, {
    size: "label",
    tone: "verify",
    style: {
      display: 'block',
      letterSpacing: 'var(--ee-tr-label)'
    }
  }, "CURRENTLY SHIPPING")), /*#__PURE__*/React.createElement("td", {
    style: {
      padding: 'var(--ee-3) var(--ee-4)',
      fontSize: 'var(--ee-body-s)',
      color: 'var(--ee-ink-2)'
    }
  }, r.sku), /*#__PURE__*/React.createElement("td", {
    style: {
      padding: 'var(--ee-3) var(--ee-4)',
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(Measured, {
    size: "bodyS"
  }, r.dose)), /*#__PURE__*/React.createElement("td", {
    style: {
      padding: 'var(--ee-3) var(--ee-4)',
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(Measured, {
    size: "bodyS",
    tone: "ink2"
  }, r.origin)), /*#__PURE__*/React.createElement("td", {
    style: {
      padding: 'var(--ee-3) var(--ee-4)',
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(Measured, {
    size: "bodyS",
    tone: "ink2"
  }, r.assay)), /*#__PURE__*/React.createElement("td", {
    style: {
      padding: 'var(--ee-3) var(--ee-4)',
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement("a", {
    href: "#",
    onClick: e => {
      e.preventDefault();
      go('report');
    },
    style: {
      fontSize: 'var(--ee-body-s)'
    }
  }, "Open \u2192"))))))), /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "limit"
  }, rows.length, " of ", LOT_ARCHIVE.length, " lots shown \xB7 archive begins 04 Dec 2025, the first batch we shipped")), /*#__PURE__*/React.createElement(Section, {
    id: "why",
    index: "\u2014",
    eyebrow: "Why this page exists",
    title: "Badges are demoted, not banned",
    width: "wide"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))',
      gap: 'var(--ee-7)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--ee-4)'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 'var(--ee-body)',
      lineHeight: 'var(--ee-lh-body)',
      color: 'var(--ee-ink-2)',
      margin: 0
    }
  }, "Across 263 collected buyer quotes, the phrase \u201Ccertificate of analysis\u201D appears zero times. \u201CThird-party tested\u201D appears once \u2014 as an accusation. What she actually says is that she does not know how much is in the capsule. So the per-capsule number gets the space, and the certification marks sit below it, where they belong."), /*#__PURE__*/React.createElement(FootnotedClaim, {
    claim: "Quantified per-capsule disclosure outranks every certification mark on this site",
    citation: "Proof hierarchy, Evolved Elements Brand Design System v1.0 \xA701. Derived from 263 verbatim buyer quotes; \u201CCOA\u201D incidence: 0.",
    citationHref: "#"
  })), /*#__PURE__*/React.createElement(ProofChart, {
    eyebrow: "Buyer vocabulary \u2014 industry trust terms",
    series: [{
      label: '“COA” / “certificate of analysis”',
      value: 0,
      display: '0'
    }, {
      label: '“country of origin”',
      value: 0,
      display: '0'
    }, {
      label: '“third-party tested”',
      value: 1,
      display: '1'
    }, {
      label: '“how much is in it”, in her words',
      value: 40,
      display: 'the demand'
    }],
    max: 40,
    denominator: "263 verbatim buyer quotes",
    axisLabel: "Times said"
  }))), /*#__PURE__*/React.createElement(Section, {
    id: "current",
    index: "\u2014",
    eyebrow: "Currently shipping",
    width: "wide",
    title: "The two lots in the warehouse today"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))',
      gap: 'var(--ee-6)'
    }
  }, /*#__PURE__*/React.createElement(LotBlock, {
    lot: "2609-NZ",
    assayDate: "12 August 2026",
    eyebrow: "Thyroid glandular \xB7 this bottle"
  }), /*#__PURE__*/React.createElement(LotBlock, {
    lot: "2609-NZ-L",
    assayDate: "12 August 2026",
    eyebrow: "Beef liver gentle \xB7 this bottle"
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))',
      gap: 'var(--ee-6)'
    }
  }, /*#__PURE__*/React.createElement(DisclosurePanel, {
    rows: [{
      label: 'Grass-fed thyroid glandular, New Zealand',
      value: '200 mg'
    }, {
      label: 'Excipients',
      value: 'none'
    }, {
      label: 'Capsules per bottle',
      value: '60'
    }]
  }), /*#__PURE__*/React.createElement(DisclosurePanel, {
    rows: [{
      label: 'Beef liver, New Zealand',
      value: '3,000 mg'
    }, {
      label: 'Excipients',
      value: 'none'
    }, {
      label: 'Capsules per bottle',
      value: '180'
    }]
  }))));
}
Object.assign(window, {
  EvidencePage,
  LOT_ARCHIVE
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/web/EvidencePage.jsx", error: String((e && e.message) || e) }); }

// ui_kits/web/LandingPage.jsx
try { (() => {
/* Evolved Elements — web UI kit · the landing page.
   The 14-section page spine, in order. Sections may be dropped from the
   bottom; none may be re-ordered — the sequence is the argument. */
const {
  Section,
  HeroStack,
  Button,
  Eyebrow,
  Measured,
  VerifiableBlock,
  LotBlock,
  DisclosurePanel,
  VerbatimQuote,
  FootnotedClaim,
  GuaranteeLockup,
  MechanismDiagram,
  ComparisonTable,
  ProofChart,
  TextField
} = window.EvolvedElementsDesignSystem_057731 || {};

/* Register-A / Register-B photography was not supplied with the brand system.
   Rather than substitute stock — which the brand forbids by name — the kit
   marks the slot and states what belongs in it. */
function ImageSlot({
  register,
  note,
  height = 320
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      height,
      background: 'var(--ee-deep)',
      border: `var(--ee-border-w) dashed var(--ee-border)`,
      borderRadius: 'var(--ee-radius-img)',
      display: 'grid',
      placeItems: 'center',
      padding: 'var(--ee-5)',
      textAlign: 'center'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--ee-2)',
      maxWidth: '46ch'
    }
  }, /*#__PURE__*/React.createElement(Eyebrow, null, "Register ", register, " \xB7 no image supplied"), /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "ink2",
    style: {
      lineHeight: 'var(--ee-lh-micro)'
    }
  }, note)));
}
function LotLookup() {
  const [entry, setEntry] = React.useState('');
  const [result, setResult] = React.useState(null);
  const LOTS = {
    '2609-NZ': {
      assay: '12 August 2026',
      origin: 'Single-source New Zealand',
      dose: '200 mg',
      ct: '60'
    },
    '2604-NZ': {
      assay: '19 April 2026',
      origin: 'Single-source New Zealand',
      dose: '200 mg',
      ct: '60'
    }
  };
  const submit = e => {
    e.preventDefault();
    const key = entry.trim().toUpperCase().replace(/^LOT\s*/, '');
    setResult(LOTS[key] ? {
      key,
      ...LOTS[key]
    } : {
      key,
      missing: true
    });
  };
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--ee-4)',
      maxWidth: 460
    }
  }, /*#__PURE__*/React.createElement("form", {
    onSubmit: submit,
    style: {
      display: 'grid',
      gap: 'var(--ee-4)'
    }
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Your lot number",
    mono: true,
    hint: "Find it on the base of your bottle, under the cap. Try 2609-NZ or 2604-NZ.",
    placeholder: "2609-NZ",
    value: entry,
    onChange: e => setEntry(e.target.value)
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    type: "submit",
    size: "compact"
  }, "Look up this batch")), result && !result.missing && /*#__PURE__*/React.createElement(VerifiableBlock, null, /*#__PURE__*/React.createElement(Eyebrow, {
    style: {
      marginBottom: 'var(--ee-2)'
    }
  }, "Lot ", result.key), /*#__PURE__*/React.createElement("dl", {
    style: {
      margin: 0,
      display: 'grid',
      gridTemplateColumns: '1fr auto',
      gap: 'var(--ee-1) var(--ee-4)'
    }
  }, [['Assay published', result.assay], ['Origin', result.origin], ['Per capsule', result.dose], ['Count', result.ct]].map(([k, v]) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: k
  }, /*#__PURE__*/React.createElement("dt", {
    style: {
      fontSize: 'var(--ee-body-s)'
    }
  }, k), /*#__PURE__*/React.createElement("dd", {
    style: {
      margin: 0,
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(Measured, {
    size: "bodyS",
    weight: 600
  }, v))))), /*#__PURE__*/React.createElement("a", {
    href: "#",
    style: {
      fontSize: 'var(--ee-body-s)',
      display: 'inline-block',
      marginTop: 'var(--ee-3)'
    }
  }, "Open this batch's report \u2192")), result && result.missing && /*#__PURE__*/React.createElement(VerifiableBlock, {
    tone: "ink",
    surface: "quiet"
  }, /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "ink2"
  }, "No published assay for \u201C", result.key, "\u201D. Either the code was mistyped, or the bottle is not ours. Both answers are useful \u2014 write to us either way.")));
}
function Faq() {
  const [open, setOpen] = React.useState(0);
  const items = [['Can I take this with levothyroxine?', 'Ask the prescriber who manages your dose. We are food, not a prescription, and we will not tell you what to do with a medication we did not prescribe. What we will tell you is exactly what is in the capsule, so that conversation can be a specific one.'], ['Will this raise my T3?', 'We do not claim that, and we will not. What we say is where the work happens, what the capsules are built from, and how much of it is in each one. Anything past that would be a claim we cannot open and check.'], ['Why two bottles instead of one blend?', 'Because the two sites need different amounts. A blend has to compromise the dose of both to fit one capsule. 200 mg of thyroid and 3,000 mg of liver do not fit in the same pill, so we did not pretend they did.'], ['What does the lot report actually show?', 'The independent assay for the batch you are holding — identity, heavy metals, microbials, and the per-capsule figure. Not a report for a batch from two years ago. Yours.']];
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid'
    }
  }, items.map(([q, a], i) => /*#__PURE__*/React.createElement("div", {
    key: q,
    style: {
      borderTop: 'var(--ee-rule-w) solid var(--ee-rule)'
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: () => setOpen(open === i ? -1 : i),
    "aria-expanded": open === i,
    style: {
      width: '100%',
      textAlign: 'left',
      background: 'none',
      border: 'none',
      padding: 'var(--ee-4) 0',
      minHeight: 'var(--ee-tap-min)',
      cursor: 'pointer',
      fontFamily: 'var(--ee-font-prose)',
      fontSize: 'var(--ee-h4)',
      fontWeight: 'var(--ee-w-semibold)',
      color: 'var(--ee-ink)',
      display: 'flex',
      justifyContent: 'space-between',
      gap: 'var(--ee-4)'
    }
  }, /*#__PURE__*/React.createElement("span", null, q), /*#__PURE__*/React.createElement(Measured, {
    tone: "limit",
    style: {
      flex: '0 0 auto'
    }
  }, open === i ? '\u2212' : '+')), open === i && /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 'var(--ee-body)',
      lineHeight: 'var(--ee-lh-body)',
      color: 'var(--ee-ink-2)',
      paddingBottom: 'var(--ee-5)',
      maxWidth: 'var(--ee-measure)',
      margin: 0
    }
  }, a))));
}
function Capture() {
  const [email, setEmail] = React.useState('');
  const [sent, setSent] = React.useState(false);
  return sent ? /*#__PURE__*/React.createElement(VerifiableBlock, null, /*#__PURE__*/React.createElement(Measured, {
    size: "bodyS"
  }, "You are on the lot list. Next assay publishes and you get one paragraph and one link.")) : /*#__PURE__*/React.createElement("form", {
    onSubmit: e => {
      e.preventDefault();
      setSent(true);
    },
    style: {
      display: 'grid',
      gap: 'var(--ee-4)',
      maxWidth: 420
    }
  }, /*#__PURE__*/React.createElement(TextField, {
    label: "Email",
    type: "email",
    required: true,
    value: email,
    onChange: e => setEmail(e.target.value),
    hint: "Every lot we publish is an email. One paragraph, one link to the report. Nothing else."
  }), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    type: "submit",
    size: "compact"
  }, "Send me each lot report"));
}
function LandingPage({
  go,
  mechanismRef
}) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Section, {
    id: "recognition",
    index: "01",
    width: "container",
    style: {
      paddingTop: 'var(--ee-9)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1.15fr) minmax(0,0.85fr)',
      gap: 'var(--ee-8)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement(HeroStack, {
    eyebrow: "Lot 2609-NZ \xB7 report published",
    headline: "They've raised your dose at least once, and it didn't change anything.",
    subhead: "You're not imagining it. Here is where the conversation usually stops \u2014 and what happens next.",
    proofFigure: "1 of 33",
    proofLabel: "Brands assessed that publish a lot report for the bottle in your hand"
  }), /*#__PURE__*/React.createElement(ImageSlot, {
    register: "A \u2014 Evidence",
    height: 380,
    note: "The lot report on a desk, flat top-down, available light. Tight crop \u2014 the document is the subject. No props, no styling."
  }))), /*#__PURE__*/React.createElement(Section, {
    id: "disqualifier",
    index: "02",
    eyebrow: "Who this is not for",
    title: "If any of these are true, close the tab."
  }, /*#__PURE__*/React.createElement("ul", {
    style: {
      display: 'grid',
      gap: 'var(--ee-3)',
      margin: 0,
      padding: 0,
      listStyle: 'none'
    }
  }, ['You are looking for something to replace your medication. This is food. It replaces nothing.', 'You want a number to move by Friday. The expectation curve below opens with “probably nothing”.', 'You would rather not read a certificate. Most of what we have to offer is paperwork.'].map(t => /*#__PURE__*/React.createElement("li", {
    key: t,
    style: {
      display: 'grid',
      gridTemplateColumns: 'auto 1fr',
      gap: 'var(--ee-3)',
      fontSize: 'var(--ee-body)',
      lineHeight: 'var(--ee-lh-body)',
      color: 'var(--ee-ink-2)'
    }
  }, /*#__PURE__*/React.createElement(Measured, {
    tone: "limit"
  }, "\u2014"), /*#__PURE__*/React.createElement("span", null, t))))), /*#__PURE__*/React.createElement(Section, {
    id: "gap",
    index: "03",
    eyebrow: "The gap",
    title: "Your labs are normal. You are not."
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 'var(--ee-body)',
      lineHeight: 'var(--ee-lh-body)',
      color: 'var(--ee-ink-2)',
      maxWidth: 'var(--ee-measure)'
    }
  }, "The prescription supplies the hormone. It does not supply the material the second step runs on. When the dose goes up and nothing changes, that is the part of the conversation that usually does not happen \u2014 because the number on the page is inside range, and your afternoon is not on the page."), /*#__PURE__*/React.createElement(VerbatimQuote, {
    quote: "I could sleep 10 hours and still wake up tired",
    source: "HealthUnlocked / ThyroidUK \xB7 buyer research, 263 quotes collected",
    sourceHref: "#"
  })), /*#__PURE__*/React.createElement(Section, {
    id: "form",
    index: "04",
    eyebrow: "Food vs isolates",
    title: "Why the form it arrives in is the argument"
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 'var(--ee-body)',
      lineHeight: 'var(--ee-lh-body)',
      color: 'var(--ee-ink-2)',
      maxWidth: 'var(--ee-measure)'
    }
  }, "An isolate delivers one compound at a dose someone chose. A whole food delivers the matrix the compound arrived in. We are not going to tell you the matrix does something an isolate cannot \u2014 that is a claim we could not open and check. We will tell you which one is in the bottle, and how much."), /*#__PURE__*/React.createElement(FootnotedClaim, {
    claim: "No blend, no filler, no proprietary mix \u2014 the panel is the formula",
    citation: "Supplement facts panel, lot 2609-NZ. Excipients: none. 25 of 63 brands assessed publish a precise unrounded count; 2 of 23 weak-performing brands do.",
    citationHref: "#"
  })), /*#__PURE__*/React.createElement(Section, {
    id: "mechanism",
    index: "05",
    eyebrow: "Two sites, one pathway",
    title: "Your body makes the hormone in one organ and activates it in another",
    width: "wide"
  }, /*#__PURE__*/React.createElement("div", {
    ref: mechanismRef
  }, /*#__PURE__*/React.createElement(MechanismDiagram, {
    eyebrow: null
  }))), /*#__PURE__*/React.createElement(Section, {
    id: "pair",
    index: "06",
    eyebrow: "The pair",
    title: "Two bottles, because there are two sites",
    width: "wide"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(280px,1fr))',
      gap: 'var(--ee-6)'
    }
  }, [{
    name: 'Thyroid Glandular',
    organ: 'Grass-fed thyroid glandular',
    origin: 'Single-source New Zealand',
    dose: '200 mg',
    ct: '60',
    accent: 'var(--ee-verify)'
  }, {
    name: 'Beef Liver Gentle',
    organ: 'Beef liver',
    origin: 'Single-source New Zealand',
    dose: '3,000 mg',
    ct: '180',
    accent: 'var(--ee-mechanism)'
  }].map(p => /*#__PURE__*/React.createElement("div", {
    key: p.name,
    style: {
      background: 'var(--ee-card)',
      borderRadius: 'var(--ee-radius)',
      border: 'var(--ee-rule-w) solid var(--ee-rule)',
      padding: 'var(--ee-5)',
      display: 'grid',
      gap: 'var(--ee-4)'
    }
  }, /*#__PURE__*/React.createElement(ImageSlot, {
    register: "A \u2014 Evidence",
    height: 180,
    note: "The bottle on a counter, beside a kettle, next to the labs. Not on a seamless. No shadow, no reflection."
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("h3", {
    style: {
      fontSize: 'var(--ee-h3)',
      lineHeight: 'var(--ee-lh-h3)',
      fontWeight: 'var(--ee-w-semibold)',
      margin: 0
    }
  }, p.name), /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "limit",
    style: {
      display: 'block',
      marginTop: 'var(--ee-1)'
    }
  }, p.organ.toUpperCase(), " \xB7 ", p.dose, " \xB7 ", p.ct, " CT")), /*#__PURE__*/React.createElement(DisclosurePanel, {
    surface: "ground",
    rows: [{
      label: p.organ + ', New Zealand',
      value: p.dose
    }, {
      label: 'Excipients',
      value: 'none'
    }, {
      label: 'Capsules per bottle',
      value: p.ct
    }]
  })))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--ee-4)',
      flexWrap: 'wrap',
      alignItems: 'center'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: () => go('product')
  }, "Get the pair"), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: () => go('report')
  }, "Open the lab report for this batch")), /*#__PURE__*/React.createElement(GuaranteeLockup, {
    placement: "microline"
  })), /*#__PURE__*/React.createElement(Section, {
    id: "document",
    index: "07",
    eyebrow: "The document",
    title: "Look up the jar you are actually holding",
    width: "wide"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(300px,1fr))',
      gap: 'var(--ee-7)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement(LotLookup, null), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--ee-5)'
    }
  }, /*#__PURE__*/React.createElement(FootnotedClaim, {
    claim: "Single-source New Zealand, named on the certificate",
    citation: "Certificate of origin, lot 2609-NZ, issued 12 Aug 2026. 5 of 33 brands assessed name a single origin.",
    citationHref: "#"
  }), /*#__PURE__*/React.createElement(ProofChart, {
    eyebrow: "Brands publishing a customer-facing lot lookup",
    series: [{
      label: 'Publish a lookup',
      value: 1,
      display: '1'
    }, {
      label: 'Do not',
      value: 32,
      display: '32',
      muted: true
    }],
    denominator: "33 brands assessed",
    axisLabel: "Brands"
  })))), /*#__PURE__*/React.createElement(Section, {
    id: "labs",
    index: "08",
    eyebrow: "Her own numbers",
    title: "Ask for these four, and you will not need us to interpret them"
  }, /*#__PURE__*/React.createElement("ol", {
    style: {
      display: 'grid',
      gap: 'var(--ee-3)',
      margin: 0,
      padding: 0,
      listStyle: 'none',
      counterReset: 'l'
    }
  }, [['TSH', 'the one you already get'], ['Free T4', 'what the prescription supplies'], ['Free T3', 'what the second step produces'], ['Reverse T3', 'where it goes instead']].map(([n, w], i) => /*#__PURE__*/React.createElement("li", {
    key: n,
    style: {
      display: 'grid',
      gridTemplateColumns: 'auto auto 1fr',
      gap: 'var(--ee-3)',
      alignItems: 'baseline',
      borderBottom: 'var(--ee-rule-w) solid var(--ee-rule)',
      paddingBottom: 'var(--ee-3)'
    }
  }, /*#__PURE__*/React.createElement(Measured, {
    tone: "verify",
    size: "micro"
  }, String(i + 1).padStart(2, '0')), /*#__PURE__*/React.createElement(Measured, {
    size: "bodyS",
    weight: 600
  }, n), /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--ee-body-s)',
      color: 'var(--ee-ink-2)'
    }
  }, "\u2014 ", w)))), /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "limit"
  }, "Turns your own next blood test into proof we did not pay for. 0 of the thyroid brands assessed publish a script like this.")), /*#__PURE__*/React.createElement(Section, {
    id: "comparison",
    index: "09",
    eyebrow: "Comparison",
    title: "Including the row we lose",
    width: "wide"
  }, /*#__PURE__*/React.createElement(ComparisonTable, {
    columns: ['', 'Evolved Elements', 'Typical glandular', 'Isolate support'],
    rows: [{
      label: 'Per-capsule dose published',
      values: ['200 mg', 'not published', 'not published']
    }, {
      label: 'Lot report for your bottle',
      values: ['published', 'none', 'none']
    }, {
      label: 'Named single origin',
      values: ['New Zealand', 'globally sourced', 'not stated']
    }, {
      label: 'Excipients',
      values: ['none', 'not stated', 'magnesium stearate']
    }, {
      label: 'Guarantee length',
      values: ['90 days', '30 days', 'none published']
    }, {
      label: 'Price per month',
      values: ['$68', '$29', '$41'],
      weLose: true
    }],
    caption: "Competitor figures verified against live listings, 8 Sep 2026. We are the most expensive column. That is the trade."
  })), /*#__PURE__*/React.createElement(Section, {
    id: "expectation",
    index: "10",
    eyebrow: "Expectation curve",
    title: "Week 1 to month 6, honestly",
    width: "wide"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(auto-fit,minmax(180px,1fr))',
      gap: 'var(--ee-5)'
    }
  }, [['Week 1', 'Probably nothing. If something changes this week it is not this.'], ['Week 4', 'The earliest point anything is worth noticing. Most people notice nothing yet.'], ['Month 3', 'If it is going to matter, this is usually where it shows — in the afternoon, first.'], ['Month 6', 'The point at which we would expect you to be able to tell us whether it worked.']].map(([w, t]) => /*#__PURE__*/React.createElement("div", {
    key: w,
    style: {
      borderTop: `var(--ee-verify-rule) solid var(--ee-verify)`,
      paddingTop: 'var(--ee-3)'
    }
  }, /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    weight: 600,
    style: {
      display: 'block',
      marginBottom: 'var(--ee-2)'
    }
  }, w.toUpperCase()), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 'var(--ee-body-s)',
      lineHeight: 'var(--ee-lh-body-s)',
      color: 'var(--ee-ink-2)',
      margin: 0
    }
  }, t))))), /*#__PURE__*/React.createElement(Section, {
    id: "christine",
    index: "11",
    eyebrow: "Christine",
    title: "The founder story, in which she is not the hero",
    width: "wide"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)',
      gap: 'var(--ee-7)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 'var(--ee-body)',
      lineHeight: 'var(--ee-lh-body)',
      color: 'var(--ee-ink-2)',
      margin: 0
    }
  }, "Christine spent four years buying the same category you did, and abandoning it for the same reason: nobody would tell her how much of the active thing was in the capsule. She did not solve the biology. She solved the paperwork. That is the whole company \u2014 the assay was always possible; publishing it was the part nobody was doing."), /*#__PURE__*/React.createElement(ImageSlot, {
    register: "B \u2014 Life",
    height: 260,
    note: "A woman visibly 48\u201358 in her own kitchen, window light, unlit shadows kept, clothed for a Tuesday, composed \u2014 not delighted. Never a model who reads under 45."
  }))), /*#__PURE__*/React.createElement(Section, {
    id: "reviews",
    index: "12",
    eyebrow: "Reviews",
    title: "Precise, and reconcilable with the live profile"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--ee-6)',
      flexWrap: 'wrap',
      alignItems: 'baseline'
    }
  }, [['4.64/5', 'mean rating'], ['413', 'reviews published'], ['387', 'verified purchase']].map(([n, l]) => /*#__PURE__*/React.createElement("div", {
    key: l
  }, /*#__PURE__*/React.createElement(Measured, {
    size: "h2",
    weight: 600
  }, n), /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "limit",
    style: {
      display: 'block'
    }
  }, l.toUpperCase())))), /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "limit",
    style: {
      maxWidth: 'var(--ee-measure)',
      lineHeight: 'var(--ee-lh-micro)'
    }
  }, "Exact figures, re-checked against the live profile on 8 Sep 2026. In the study behind this brand, one competitor claimed 100,000+ reviews against a public profile showing 112."), /*#__PURE__*/React.createElement(VerbatimQuote, {
    quote: "they say they are ok ! I tell them I am not",
    source: "HealthUnlocked / ThyroidUK \xB7 user Spam1",
    sourceHref: "#"
  })), /*#__PURE__*/React.createElement(Section, {
    id: "guarantee",
    index: "13",
    width: "wide",
    surface: "quiet"
  }, /*#__PURE__*/React.createElement(GuaranteeLockup, {
    placement: "section"
  })), /*#__PURE__*/React.createElement(Section, {
    id: "faq",
    index: "14",
    eyebrow: "Questions",
    title: "What we will and will not tell you"
  }, /*#__PURE__*/React.createElement(Faq, null), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 'var(--ee-6)',
      paddingTop: 'var(--ee-6)',
      borderTop: 'var(--ee-rule-w) solid var(--ee-rule)'
    }
  }, /*#__PURE__*/React.createElement(Capture, null))));
}
Object.assign(window, {
  LandingPage,
  ImageSlot,
  LotLookup,
  Faq,
  Capture
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/web/LandingPage.jsx", error: String((e && e.message) || e) }); }

// ui_kits/web/ProductPage.jsx
try { (() => {
/* Evolved Elements — web UI kit · the product page and the report view. */
const {
  Section,
  Eyebrow,
  Measured,
  Button,
  VerifiableBlock,
  TextField,
  LotBlock,
  DisclosurePanel,
  FootnotedClaim,
  GuaranteeLockup,
  MechanismDiagram
} = window.EvolvedElementsDesignSystem_057731 || {};
const {
  ImageSlot
} = window;
function ProductPage({
  go
}) {
  const [plan, setPlan] = React.useState('subscribe');
  const [added, setAdded] = React.useState(false);
  const price = plan === 'subscribe' ? '$68.00' : '$79.00';
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Section, {
    id: "product",
    index: "The pair",
    width: "container"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1fr) minmax(0,1fr)',
      gap: 'var(--ee-8)',
      alignItems: 'start'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--ee-4)'
    }
  }, /*#__PURE__*/React.createElement(ImageSlot, {
    register: "A \u2014 Evidence",
    height: 380,
    note: "Both bottles on a counter, beside a kettle, next to the labs. One family on the Ground colour. No shadow, no reflection, never a seamless white."
  }), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gridTemplateColumns: 'repeat(3,1fr)',
      gap: 'var(--ee-3)'
    }
  }, /*#__PURE__*/React.createElement(ImageSlot, {
    register: "A",
    height: 92,
    note: "Capsule contents weighed, number legible"
  }), /*#__PURE__*/React.createElement(ImageSlot, {
    register: "A",
    height: 92,
    note: "Certificate of origin, tight crop"
  }), /*#__PURE__*/React.createElement(ImageSlot, {
    register: "B",
    height: 92,
    note: "Her kitchen, 3pm, available light"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--ee-5)'
    }
  }, /*#__PURE__*/React.createElement(Eyebrow, {
    tone: "verify"
  }, "Lot 2609-NZ \xB7 assay published 12 Aug 2026"), /*#__PURE__*/React.createElement("h1", {
    style: {
      fontSize: 'var(--ee-h2)',
      lineHeight: 'var(--ee-lh-h2)',
      letterSpacing: 'var(--ee-tr-h2)',
      fontWeight: 700,
      margin: 0
    }
  }, "The pair \u2014 grass-fed thyroid glandular and beef liver"), /*#__PURE__*/React.createElement("p", {
    style: {
      fontSize: 'var(--ee-lead)',
      lineHeight: 'var(--ee-lh-lead)',
      color: 'var(--ee-ink-2)',
      margin: 0
    }
  }, "One bottle for the site that makes it. One for the site that activates it. Sold together because the argument is that there are two."), /*#__PURE__*/React.createElement(DisclosurePanel, {
    eyebrow: "Per capsule, per bottle",
    rows: [{
      label: 'Grass-fed thyroid glandular, New Zealand',
      value: '200 mg'
    }, {
      label: 'Beef liver, New Zealand',
      value: '3,000 mg'
    }, {
      label: 'Excipients',
      value: 'none'
    }, {
      label: 'Capsules — thyroid / liver',
      value: '60 / 180'
    }],
    footnote: "This panel is the formula. There is no proprietary blend to disclose because there is no blend."
  }), /*#__PURE__*/React.createElement("fieldset", {
    style: {
      border: 'none',
      padding: 0,
      margin: 0,
      display: 'grid',
      gap: 'var(--ee-3)'
    }
  }, /*#__PURE__*/React.createElement("legend", {
    style: {
      padding: 0,
      marginBottom: 'var(--ee-2)'
    }
  }, /*#__PURE__*/React.createElement(Eyebrow, null, "How you buy it")), [['subscribe', 'Every 30 days', '$68.00', 'Cancel anytime, in one click, from any email we send.'], ['once', 'One time', '$79.00', 'No account, no reminders.']].map(([k, l, p, note]) => /*#__PURE__*/React.createElement("label", {
    key: k,
    style: {
      display: 'grid',
      gridTemplateColumns: 'auto 1fr auto',
      gap: 'var(--ee-3)',
      alignItems: 'baseline',
      padding: 'var(--ee-3) var(--ee-4)',
      cursor: 'pointer',
      background: 'var(--ee-card)',
      borderRadius: 'var(--ee-radius)',
      border: `var(--ee-border-w) solid ${plan === k ? 'var(--ee-border)' : 'var(--ee-rule)'}`,
      borderLeft: plan === k ? `var(--ee-verify-rule) solid var(--ee-verify)` : `var(--ee-border-w) solid var(--ee-rule)`
    }
  }, /*#__PURE__*/React.createElement("input", {
    type: "radio",
    name: "plan",
    checked: plan === k,
    onChange: () => setPlan(k),
    style: {
      accentColor: 'var(--ee-verify)',
      width: 18,
      height: 18
    }
  }), /*#__PURE__*/React.createElement("span", null, /*#__PURE__*/React.createElement("span", {
    style: {
      fontSize: 'var(--ee-body-s)',
      fontWeight: 600
    }
  }, l), plan === k && /*#__PURE__*/React.createElement(Measured, {
    size: "label",
    tone: "verify",
    style: {
      display: 'block',
      letterSpacing: 'var(--ee-tr-label)'
    }
  }, "SELECTED"), /*#__PURE__*/React.createElement("span", {
    style: {
      display: 'block',
      fontSize: 'var(--ee-micro)',
      color: 'var(--ee-limit)',
      marginTop: 2
    }
  }, note)), /*#__PURE__*/React.createElement(Measured, {
    size: "bodyS",
    weight: 600
  }, p)))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--ee-4)',
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: () => setAdded(true)
  }, added ? `Added · ${price}` : 'Get the pair'), /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onClick: () => go('report')
  }, "Open the lab report for this batch")), /*#__PURE__*/React.createElement(GuaranteeLockup, {
    placement: "microline"
  }), /*#__PURE__*/React.createElement(LotBlock, {
    lot: "2609-NZ",
    assayDate: "12 August 2026"
  })))), /*#__PURE__*/React.createElement(Section, {
    id: "p-mechanism",
    index: "\u2014",
    eyebrow: "Two sites, one pathway",
    width: "wide",
    title: "Why it is a pair and not a blend"
  }, /*#__PURE__*/React.createElement(MechanismDiagram, {
    eyebrow: null
  })), /*#__PURE__*/React.createElement(Section, {
    id: "p-guarantee",
    index: "\u2014",
    width: "wide",
    surface: "quiet"
  }, /*#__PURE__*/React.createElement(GuaranteeLockup, {
    placement: "section"
  })));
}

/* The document the whole brand points at. Register A, as a page. */
function ReportPage({
  go
}) {
  return /*#__PURE__*/React.createElement(Section, {
    id: "report",
    index: "Report",
    width: "wide"
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      gap: 'var(--ee-3)',
      alignItems: 'center',
      flexWrap: 'wrap'
    }
  }, /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    size: "compact",
    onClick: () => go('evidence')
  }, "\u2190 All lots"), /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "limit"
  }, "Third-party assay \xB7 published 12 Aug 2026 \xB7 4 pages")), /*#__PURE__*/React.createElement("div", {
    style: {
      background: 'var(--ee-card)',
      borderRadius: 'var(--ee-radius)',
      border: 'var(--ee-rule-w) solid var(--ee-rule)',
      padding: 'var(--ee-7)',
      display: 'grid',
      gap: 'var(--ee-5)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'flex',
      justifyContent: 'space-between',
      gap: 'var(--ee-5)',
      flexWrap: 'wrap',
      borderBottom: 'var(--ee-border-w) solid var(--ee-border)',
      paddingBottom: 'var(--ee-4)'
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Eyebrow, null, "Certificate of analysis"), /*#__PURE__*/React.createElement(Measured, {
    size: "h2",
    weight: 600,
    style: {
      display: 'block',
      marginTop: 'var(--ee-2)'
    }
  }, "LOT 2609-NZ")), /*#__PURE__*/React.createElement("div", {
    style: {
      textAlign: 'right'
    }
  }, /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "limit",
    style: {
      display: 'block'
    }
  }, "GRASS-FED THYROID GLANDULAR"), /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "limit",
    style: {
      display: 'block'
    }
  }, "SINGLE-SOURCE NEW ZEALAND"), /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "limit",
    style: {
      display: 'block'
    }
  }, "60 CAPSULES \xB7 200 MG"))), /*#__PURE__*/React.createElement("table", {
    style: {
      width: '100%',
      borderCollapse: 'collapse'
    }
  }, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", {
    style: {
      background: 'var(--ee-deep)'
    }
  }, ['ASSAY', 'RESULT', 'SPECIFICATION', 'METHOD'].map((h, i) => /*#__PURE__*/React.createElement("th", {
    key: h,
    scope: "col",
    style: {
      fontFamily: 'var(--ee-font-mono)',
      fontSize: 'var(--ee-label)',
      letterSpacing: 'var(--ee-tr-label)',
      fontWeight: 500,
      textAlign: i ? 'right' : 'left',
      padding: 'var(--ee-3) var(--ee-4)'
    }
  }, h)))), /*#__PURE__*/React.createElement("tbody", null, [['Identity — grass-fed thyroid tissue', 'Conforms', 'Conforms', 'PCR'], ['Content per capsule', '201.4 mg', '190–210 mg', 'Gravimetric'], ['Lead', '< 0.01 ppm', '< 0.50 ppm', 'ICP-MS'], ['Arsenic', '< 0.01 ppm', '< 1.00 ppm', 'ICP-MS'], ['Cadmium', '< 0.01 ppm', '< 0.30 ppm', 'ICP-MS'], ['Mercury', '< 0.01 ppm', '< 0.10 ppm', 'ICP-MS'], ['Total aerobic count', '< 100 cfu/g', '< 10,000 cfu/g', 'USP 2021'], ['Salmonella', 'Absent', 'Absent', 'USP 2022']].map(r => /*#__PURE__*/React.createElement("tr", {
    key: r[0],
    style: {
      borderBottom: 'var(--ee-rule-w) solid var(--ee-rule)'
    }
  }, /*#__PURE__*/React.createElement("th", {
    scope: "row",
    style: {
      textAlign: 'left',
      fontWeight: 400,
      fontSize: 'var(--ee-body-s)',
      padding: 'var(--ee-3) var(--ee-4)'
    }
  }, r[0]), r.slice(1).map((c, i) => /*#__PURE__*/React.createElement("td", {
    key: i,
    style: {
      textAlign: 'right',
      padding: 'var(--ee-3) var(--ee-4)'
    }
  }, /*#__PURE__*/React.createElement(Measured, {
    size: "bodyS",
    weight: i === 0 ? 600 : 400,
    tone: i === 0 ? 'ink' : 'ink2'
  }, c))))))), /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "limit",
    style: {
      lineHeight: 'var(--ee-lh-micro)'
    }
  }, "Sample drawn 04 Aug 2026 \xB7 analysed 08\u201311 Aug 2026 \xB7 report issued 12 Aug 2026. Laboratory name, accreditation number and signatory appear on the PDF. This HTML view is a transcription; the PDF is the record.")), /*#__PURE__*/React.createElement(FootnotedClaim, {
    claim: "Content per capsule measured at 201.4 mg against a 200 mg label claim",
    citation: "Gravimetric assay, lot 2609-NZ, 08\u201311 Aug 2026. Specification 190\u2013210 mg. Full document linked.",
    citationHref: "#"
  }));
}
Object.assign(window, {
  ProductPage,
  ReportPage
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/web/ProductPage.jsx", error: String((e && e.message) || e) }); }

// ui_kits/web/WebShell.jsx
try { (() => {
/* Evolved Elements — web UI kit · shared shell.
   Header, footer and the sticky buy bar. Composes the design system's
   navigation primitives; does not re-implement them. */
const {
  SiteHeader,
  AnnouncementBar,
  StickyBuyBar,
  Button,
  Eyebrow,
  Measured,
  LotBlock,
  GuaranteeLockup
} = window.EvolvedElementsDesignSystem_057731 || {};
const LOGO = 'https://cdn.shopify.com/s/files/1/0799/4857/9091/files/ee-lp-logo-transparent.png';

/* Navigation is organised by her problem, not by our catalogue.
   "Our Evidence" is a permanent top-level item. */
const NAV = [{
  label: 'Why the dose increase did nothing',
  href: '#gap',
  route: 'landing'
}, {
  label: 'Two sites, one pathway',
  href: '#mechanism',
  route: 'landing'
}, {
  label: 'Our Evidence',
  href: '#evidence',
  route: 'evidence'
}, {
  label: 'The pair',
  href: '#pair',
  route: 'product'
}];
function SiteFooter({
  go
}) {
  return /*#__PURE__*/React.createElement("footer", {
    style: {
      background: 'var(--ee-ground)',
      borderTop: 'var(--ee-rule-w) solid var(--ee-rule)',
      padding: 'var(--ee-8) var(--ee-gutter) var(--ee-7)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--ee-container)',
      margin: '0 auto',
      display: 'grid',
      gridTemplateColumns: 'minmax(0,1.2fr) minmax(0,1fr) minmax(0,1fr)',
      gap: 'var(--ee-7)'
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--ee-4)'
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: LOGO,
    alt: "Evolved Elements",
    style: {
      height: 30,
      width: 'auto'
    }
  }), /*#__PURE__*/React.createElement(LotBlock, {
    lot: "2609-NZ",
    assayDate: "12 August 2026",
    surface: "ground"
  })), /*#__PURE__*/React.createElement("nav", {
    style: {
      display: 'grid',
      gap: 'var(--ee-3)',
      alignContent: 'start'
    }
  }, /*#__PURE__*/React.createElement(Eyebrow, null, "The argument"), [['The gap the pill leaves', 'landing'], ['Two sites, one pathway', 'landing'], ['What is in the capsule', 'product'], ['Our Evidence', 'evidence'], ['The lot archive', 'evidence']].map(([l, r]) => /*#__PURE__*/React.createElement("a", {
    key: l,
    href: "#",
    onClick: e => {
      e.preventDefault();
      go(r);
    },
    style: {
      fontSize: 'var(--ee-body-s)'
    }
  }, l))), /*#__PURE__*/React.createElement("div", {
    style: {
      display: 'grid',
      gap: 'var(--ee-3)',
      alignContent: 'start'
    }
  }, /*#__PURE__*/React.createElement(Eyebrow, null, "The paperwork"), ['The 90-Day Afternoon Guarantee', 'Certificate of origin, lot 2609-NZ', 'Third-party assay, 12 Aug 2026', 'Christine, and what she got wrong'].map(l => /*#__PURE__*/React.createElement("a", {
    key: l,
    href: "#",
    onClick: e => e.preventDefault(),
    style: {
      fontSize: 'var(--ee-body-s)'
    }
  }, l)))), /*#__PURE__*/React.createElement("div", {
    style: {
      maxWidth: 'var(--ee-container)',
      margin: '0 auto',
      marginTop: 'var(--ee-7)',
      paddingTop: 'var(--ee-4)',
      borderTop: 'var(--ee-rule-w) solid var(--ee-rule)'
    }
  }, /*#__PURE__*/React.createElement(Measured, {
    size: "micro",
    tone: "limit",
    style: {
      display: 'block',
      maxWidth: 'var(--ee-measure)'
    }
  }, "Bathing Evolved LLC \xB7 Evolved Elements. These statements have not been evaluated by the Food and Drug Administration. This product is not intended to diagnose, treat, cure or prevent any disease.")));
}
function WebShell({
  route,
  go,
  children,
  showBuyBar
}) {
  return /*#__PURE__*/React.createElement("div", {
    style: {
      minHeight: '100%',
      background: 'var(--ee-ground)'
    }
  }, /*#__PURE__*/React.createElement(AnnouncementBar, {
    href: "#",
    linkLabel: "Open the report \u2192"
  }, "LOT 2609-NZ \xB7 third-party assay published 12 Aug 2026"), /*#__PURE__*/React.createElement(GuaranteeLockup, {
    placement: "utility"
  }), /*#__PURE__*/React.createElement(SiteHeader, {
    logoSrc: LOGO,
    items: NAV.map(n => ({
      label: n.label,
      href: n.href
    })),
    activeHref: (NAV.find(n => n.route === route) || NAV[0]).href,
    ctaHref: "#pair"
  }), /*#__PURE__*/React.createElement("main", null, children), /*#__PURE__*/React.createElement(SiteFooter, {
    go: go
  }), /*#__PURE__*/React.createElement(StickyBuyBar, {
    visible: showBuyBar,
    price: "$68 / month"
  }));
}
Object.assign(window, {
  WebShell,
  SiteFooter,
  NAV,
  LOGO
});
})(); } catch (e) { __ds_ns.__errors.push({ path: "ui_kits/web/WebShell.jsx", error: String((e && e.message) || e) }); }

__ds_ns.Button = __ds_scope.Button;

__ds_ns.Eyebrow = __ds_scope.Eyebrow;

__ds_ns.Icon = __ds_scope.Icon;

__ds_ns.Measured = __ds_scope.Measured;

__ds_ns.VerifiableBlock = __ds_scope.VerifiableBlock;

__ds_ns.ComparisonTable = __ds_scope.ComparisonTable;

__ds_ns.ProofChart = __ds_scope.ProofChart;

__ds_ns.TextField = __ds_scope.TextField;

__ds_ns.MechanismDiagram = __ds_scope.MechanismDiagram;

__ds_ns.AnnouncementBar = __ds_scope.AnnouncementBar;

__ds_ns.SiteHeader = __ds_scope.SiteHeader;

__ds_ns.StickyBuyBar = __ds_scope.StickyBuyBar;

__ds_ns.HeroStack = __ds_scope.HeroStack;

__ds_ns.Section = __ds_scope.Section;

__ds_ns.DisclosurePanel = __ds_scope.DisclosurePanel;

__ds_ns.FootnotedClaim = __ds_scope.FootnotedClaim;

__ds_ns.GuaranteeLockup = __ds_scope.GuaranteeLockup;

__ds_ns.LotBlock = __ds_scope.LotBlock;

__ds_ns.VerbatimQuote = __ds_scope.VerbatimQuote;

})();
